import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Typography, Button, Form, Input, Space, InputNumber, Card, Divider, Row, Col, message, Tooltip, Spin, Modal, Collapse, Radio, Checkbox, Select, DatePicker } from 'antd';
import { DeleteOutlined, PlusOutlined, ExclamationCircleOutlined, QuestionCircleOutlined, DollarOutlined, ReloadOutlined, UpOutlined, DownOutlined, LeftOutlined, } from '@ant-design/icons';
import SidebarLayout from './SidebarLayout';
import _BankerService from '../../modules/BankerService';
import { COMMON_ERROR_MSG } from '../../constants/constants';
import { repaymentBasisOptions } from '../../constants/DataConstants';
import { routes } from '../../routes/Routes';
import { useHistory, useLocation } from "react-router-dom";
import CurrencyInput from '../../components/CurrencyInput';

import PercentInput from '../../components/PercentInput';
import PhoneInput from "react-phone-input-auto-format";
// import ApplicationList from './ApplicationList';
import DonutChart from '../../components/DonutChart';
import IntegerInput from '../../components/IntergerInput';
import ApplicationList from './ApplicationList';
import moment from 'moment';
import _commonService from '../../modules/commonService';
import IntegerDecimalInput from '../../components/IntegerDecimalInput';
import FormItemInput from '../../components/FormItems/FormItemInput';
import FormItemPhoneNumber from '../../components/FormItems/FormItemPhoneNumber';
import FormItemCurrencyInput from '../../components/FormItems/FormItemCurrencyInput';
import FormItemIntegerInput from '../../components/FormItems/FormItemIntegerInput';
import FormItemDecimalInput from '../../components/FormItems/FormItemDecimalInput';
import ButtonComponent from '../../components/Button/Button';
import "./AddEditSponsers.scss";
import _NewapplicationService from '../../modules/NewapplicationService';
import _BankAdminService from '../../modules/BankAdminService';
import CreditFacilityReportSection from './CreditFacilityReportSection';

const { Title, Text } = Typography;
const { confirm } = Modal;
const { Panel } = Collapse;
const ADD_NEW_FIRM = "add-new-firm";
const FIRM_SEARCH_MIN_CHARS = 3;
const FIRM_SEARCH_DEBOUNCE_MS = 400;

const AddEditSponsers = () => {
    const addClickedRef = useRef(false);
    const [form] = Form.useForm();
    const history = useHistory();
    const location = useLocation();
    const [allApplications, setAllApplications] = useState([]);
    const [autoFocusApplicantIndex, setAutoFocusApplicantIndex] = useState(null);
    const [creditFacilityValue, setCreditFacilityValue] = useState(null);
    const [tenorYearsValue, setTenorYearsValue] = useState(undefined);
    const [securityValue, setSecurityValue] = useState(undefined);
    const [repaymentBasisNameValue, setRepaymentBasisNameValue] = useState(undefined);
    const [typeOfBusinessValue, setTypeOfBusinessValue] = useState(undefined);
    let data = location.state;
    let sponsId = 0;
    if (data && data.sponserId) {
        sponsId = data.sponserId;
    }

    const [sponserId] = useState(sponsId);

    // Reporting Requirements (Credit Facility Report section): collected here, on this same
    // form, exactly like Fund/Assign Internal Stakeholders -- only persisted when the whole
    // form is saved (see listSponserReportingRequirementModel/deletedReportingRequirementIds
    // in the AddOrUpdateSponser payload below), so a brand-new facility can have covenants
    // configured before it has a saved Id.
    const [reportingRequirements, setReportingRequirements] = useState([]);
    const [deletedReportingRequirementIds, setDeletedReportingRequirementIds] = useState([]);

    const [loading, setLoading] = useState(false);
    const [sponserData, setSponserData] = useState([]);
    const [activePanelKey, setActivePanelKey] = useState(['1']);
    const [searchTerm, setSearchTerm] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [sortBy, setSortBy] = useState(null);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [debouncedSearchText, setDebouncedSearchText] = useState("");
    const [applicationStatus, setApplicationStatus] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [assetClassOptions, setAssetClassOptions] = useState([]);
    const [loanProgramOptions, setLoanProgramOptions] = useState([]);
    const [loanStructureTypeOptions, setLoanStructureTypeOptions] = useState([]);
    const [typeOfBusinessOptions, setTypeOfBusinessOptions] = useState([]);
    const [firmMasterOptions, setFirmMasterOptions] = useState([]);
    const [firmSearchTerm, setFirmSearchTerm] = useState("");
    const [firmSearchLoading, setFirmSearchLoading] = useState(false);
    const firmSearchTimeoutRef = useRef(null);
    const [showAddNewFirm, setShowAddNewFirm] = useState(false);
    const [isExistingFirmSelected, setIsExistingFirmSelected] = useState(false);
    const [corporateRepaymentBasisOptions, setCorporateRepaymentBasisOptions] = useState([]);
    const [fundType, setFundType] = useState("single");
    const [loanOfficerOptions, setLoanOfficerOptions] = useState([]);
    const [seniorPrivateBankerOptions, setSeniorPrivateBankerOptions] = useState([]);
    const [underwriterBankerOptions, setUnderwriterBankerOptions] = useState([]);
    const [privateWealthAdvisorOptions, setPrivateWealthAdvisorOptions] = useState([]);
    const [complianceAdminOptions, setComplianceAdminOptions] = useState([]);
    const [existingSponserUsers, setExistingSponserUsers] = useState([]);
    const [existingFirmAdminChecked, setExistingFirmAdminChecked] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
        setPassword("");
        setPasswordError("");
    };

    const handleOk = async () => {
        if (!password.trim()) {
            setPasswordError("Banker Login Password is required");
            return;
        }

        let reqObj = {
            "BankerPassword": password,
            "BankerId": Number(localStorage.getItem("BankerId")),
            "SponserId": sponserId
        }

        setLoading(true);
        try {
            const res = await _BankerService.deleteSponserApplicantsData(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                setPasswordError("");
                setIsModalOpen(false);
                history.push(routes.sponsors.path);
                // getSponserDataBySponserId(sponserId);
                // getApplicationListBySponserId(sponserId);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setPassword("");
        setPasswordError("");
    };

    useEffect(() => {
        const selectedLoanProgramNameForFirmAdmin = loanProgramOptions.find((item) => item.Id === creditFacilityValue)?.Name;
        const applicants = form.getFieldValue("applicants") || [];

        if (selectedLoanProgramNameForFirmAdmin === "Corporate Loan" || selectedLoanProgramNameForFirmAdmin === "Subscription Line of Credit") {
            if (applicants.length > 0) {
                const updatedApplicants = applicants.map((app, index) => ({
                    ...app,
                    roleId: index === 0 ? 6 : undefined // only first becomes Firm Admin
                }));

                form.setFieldsValue({ applicants: updatedApplicants });
            }
        } else if (selectedLoanProgramNameForFirmAdmin === "Loan Program" || selectedLoanProgramNameForFirmAdmin === "Custom Individual Financing") {
            if (applicants.length > 0) {
                const updatedApplicants = applicants.map((app) => ({
                    ...app,
                    roleId: undefined // not auto-selected; user may pick manually
                }));

                form.setFieldsValue({ applicants: updatedApplicants });
            }
        }
    }, [creditFacilityValue]);

    useEffect(() => {
        GetAllDropdownDataByName();
        return () => {
            if (firmSearchTimeoutRef.current) {
                clearTimeout(firmSearchTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (!(sponserId > 0)) {
            getActualTenantName();
        }
    }, []);

    const getActualTenantName = async () => {
        try {
            const res = await _BankAdminService.getActualTenantName();
            if (res.data) {
                form.setFieldsValue({ institution: res.data });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const selectedLoanProgramName = loanProgramOptions.find(
            (item) => item.Id === creditFacilityValue
        )?.Name;
        const repaymentBasisType = selectedLoanProgramName === "Corporate Loan" ? "corporate" : "";
        getCorporateRepaymentBasisOptions(repaymentBasisType);
    }, [creditFacilityValue, loanProgramOptions]);

    const getCorporateRepaymentBasisOptions = async (type = "") => {
        try {
            const res = await _NewapplicationService.getAllDropdownDataByName("repaymentbasistypes", type);
            if (res.data) {
                setCorporateRepaymentBasisOptions(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const GetAllDropdownDataByName = async () => {
        try {
            const assetRes = await _NewapplicationService.getAllDropdownDataByName("assetclasstypes");
            if (assetRes.data) {
                setAssetClassOptions(assetRes.data);
            }

            const loanRes = await _NewapplicationService.getAllDropdownDataByName("loanprogrametypes");
            if (loanRes.data) {
                setLoanProgramOptions(loanRes.data);
            }

            const loanStructureRes = await _NewapplicationService.getAllDropdownDataByName("loanstructuretypes");
            if (loanStructureRes.data) {
                setLoanStructureTypeOptions(loanStructureRes.data);
            }

            const businessTypeRes = await _NewapplicationService.getAllDropdownDataByName("businesstypes");
            if (businessTypeRes.data) {
                setTypeOfBusinessOptions(businessTypeRes.data);
            }

            // Firm Name is now populated via searchFirmMaster as the user types (see
            // handleFirmSearch) instead of preloading the entire firm list here.

            // New Loan Program (no sponserId yet) -> New Mode: exclude soft-deleted BankerRoles
            // memberships from the assignable user lists. Existing Loan Program -> Edit Mode: keep
            // showing everyone already eligible, unfiltered, same as before.
            const isEditMode = !!(sponserId && sponserId > 0);
            const usersRes = await _BankerService.getAllUsersDataForLoanProgram(isEditMode);
            if (usersRes.data) {
                setLoanOfficerOptions(usersRes.data.listLoanOfficers || []);
                setSeniorPrivateBankerOptions(usersRes.data.listSeniorPrivateBankers || []);
                setUnderwriterBankerOptions(usersRes.data.listUnderwriterBankers || []);
                setPrivateWealthAdvisorOptions(usersRes.data.listPrivateWealthAdvisors || []);
                setComplianceAdminOptions(usersRes.data.listComplianceAdministrators || []);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleFirmSearch = (searchText) => {
        setFirmSearchTerm(searchText || "");
        if (firmSearchTimeoutRef.current) {
            clearTimeout(firmSearchTimeoutRef.current);
        }

        const trimmedSearchText = (searchText || "").trim();
        if (trimmedSearchText.length < FIRM_SEARCH_MIN_CHARS) {
            return;
        }

        firmSearchTimeoutRef.current = setTimeout(async () => {
            setFirmSearchLoading(true);
            try {
                const res = await _BankerService.searchFirmMaster(trimmedSearchText);
                if (res.data?.Obj) {
                    setFirmMasterOptions(res.data.Obj);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setFirmSearchLoading(false);
            }
        }, FIRM_SEARCH_DEBOUNCE_MS);
    };

    const clearSelectedFirm = () => {
        setShowAddNewFirm(false);
        setIsExistingFirmSelected(false);
        setTypeOfBusinessValue(undefined);
        form.setFieldsValue({
            newFirmName: undefined,
            typeOfBusiness: undefined,
            institution: undefined,
            // FormItemPhoneNumber's underlying PhoneInput always expects a string -- an undefined
            // value crashes it (Cannot read properties of undefined (reading 'replace')), so this
            // must be reset to "" the same way the "+ Add New Firm" branch above already does.
            businessPhone: "",
            streetAddress: undefined,
            city: undefined,
            state: undefined,
            zip: undefined,
        });
    };

    const applyBusinessTypeSideEffects = (businessTypeId) => {
        const selectedName = typeOfBusinessOptions.find(
            (item) => item.Id === businessTypeId
        )?.Name;
        const targetCreditFacilityName =
            selectedName === "Corporate"
                ? "Corporate Loan"
                : selectedName === "Law Firm"
                    ? "Loan Program"
                    : null;
        if (targetCreditFacilityName) {
            const matchedCreditFacility = loanProgramOptions.find(
                (item) => item.Name === targetCreditFacilityName
            );
            if (matchedCreditFacility) {
                setCreditFacilityValue(matchedCreditFacility.Id);
                setRepaymentBasisNameValue(undefined);
                form.setFieldsValue({
                    creditFacility: matchedCreditFacility.Id,
                    repaymentBasis: undefined,
                    amortizationYears: undefined,
                });
            }
        }
    };

    useEffect(() => {
        // getApplicationListBySponserId(sponserId));
        if (sponserId && sponserId > 0) {
            getApplicationListBySponserId(sponserId);
            setActivePanelKey([]);
        }
    }, [debouncedSearchText, applicationStatus, toDate, sortBy, pageIndex, pageSize]);

    useEffect(() => {
        if (debouncedSearchText !== "") {
            setPageIndex(1);
            setPageSize(10);
        }
    }, [debouncedSearchText]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchText(searchTerm && searchTerm.trim());
        }, 900);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const getApplicationListBySponserId = async () => {
        const params = {
            sponserId: sponserId,
            ByAppStatus: applicationStatus,
            startDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
            endDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
            pageIndex,
            pageSize,
            searchTerm: debouncedSearchText,
            sortBy,
            sortAsc: true,
        };

        setLoading(true);
        try {
            const res = await _BankerService.getApplicationListBySponserId(params);
            if (res.data.IsSuccess) {
                let resObj = res?.data?.Obj?.List;
                setAllApplications(resObj);
                setTotalCount(res?.data?.Obj?.TotalRecords || 0);
                setLoading(false);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
                setLoading(false);
            }
        } catch (error) {
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };

    const handleClearFilters = () => {
        setSearchTerm("");
        setFromDate(null);
        setToDate(null);
        setSortBy(null);
        setApplicationStatus(0);
        setPageIndex(1);
        setPageSize(10);
    };

    const handlePaginationChange = (page, size) => {
        setPageIndex(page);
        setPageSize(size);
    };

    useEffect(() => {
        if (sponserId && sponserId > 0) {
            getSponserDataBySponserId();
        } else {
            setSponserData({
                applicants: [{ name: '', contactNumber: '', email: '', gpCommitment: null, roleId: 6 }],
                funds: [{ id: 0, fundName: "", assetClass: undefined, fundSize: "", vintageYear: null }],
                fundType: "single",
            });
        }
    }, []);

    const getSponserDataBySponserId = async () => {
        try {
            setLoading(true);

            const res = await _BankerService.getSponserDataBySponserId(sponserId);

            if (res.data.IsSuccess) {
                setLoading(false);
                let resObj = res.data.Obj;

                const loadedFundType = resObj.listsponserFundModel?.length > 1 ? "multi" : "single";
                setFundType(loadedFundType);

                const loadedFunds = (resObj.listsponserFundModel || []).map(item => ({
                    id: item.Id,
                    fundName: item.FundName?.trim() || "",
                    assetClass: item.AssetClassTypeId || undefined,
                    fundSize: item.FundValue ? String(item.FundValue) : "",
                    vintageYear: item.VintageYear
                        ? moment(
                            String(item.VintageYear).includes("/")
                                ? item.VintageYear
                                : `01/${item.VintageYear}`,
                            "MM/YYYY"
                        )
                        : null,
                }));

                const fundNameToId = new Map(loadedFunds.map(f => [f.fundName, f.id]));

                const loadedUsers = resObj.listSponserUsersModel || [];
                setExistingSponserUsers(loadedUsers);

                setCreditFacilityValue(resObj.LoanProgrameTypeId);
                setTenorYearsValue(resObj.Tenor_Years);
                setSecurityValue(resObj.Security);
                setRepaymentBasisNameValue(resObj.RepaymentBasis);
                setTypeOfBusinessValue(resObj.BusinessTypeId ?? resObj.TypeOfBusiness);
                setShowAddNewFirm(!(resObj.FirmId && resObj.FirmId > 0));
                setIsExistingFirmSelected(!!(resObj.FirmId && resObj.FirmId > 0));
                if (resObj.FirmId && resObj.FirmId > 0) {
                    // Seed the search-driven Firm Name Select with the already-selected firm so its
                    // label renders correctly (field is disabled on edit, so no search is triggered).
                    setFirmMasterOptions([{
                        Id: resObj.FirmId,
                        FirmName: resObj.CompanyName,
                        BusinessTypeId: resObj.BusinessTypeId,
                        Institution: resObj.Institution,
                        ContactNumber: resObj.ContactNumber,
                        StreetAddress: resObj.StreetAddress,
                        City: resObj.City,
                        State: resObj.State,
                        ZipCode: resObj.ZipCode,
                    }]);
                }
                setSponserData({
                    ...resObj,
                    firm: resObj.FirmId && resObj.FirmId > 0 ? resObj.FirmId : ADD_NEW_FIRM,
                    newFirmName: resObj.FirmId && resObj.FirmId > 0 ? undefined : resObj.CompanyName,
                    institution: resObj.Institution,
                    businessPhone: resObj.ContactNumber,
                    typeOfBusiness: resObj.BusinessTypeId ?? resObj.TypeOfBusiness,
                    yearsAssociated: resObj.YearsAssociated,
                    streetAddress: resObj.StreetAddress,
                    city: resObj.City,
                    state: resObj.State,
                    zip: resObj.ZipCode,
                    creditFacility: resObj.LoanProgrameTypeId,
                    creditFacilityName: resObj.CreditFacilityName,
                    assetClass: resObj.AssetClassTypeId,
                    interestRate: resObj.IntrestExpense,
                    commitmentFee: resObj.CommitmentFee,
                    tenorYears: resObj.Tenor_Years,
                    tenorOther: resObj.Tenor_Other,
                    security: resObj.Security,
                    guarantorName: resObj.GuranterName,
                    uncalledCapital: resObj.UncalledCapital,
                    costBasis: resObj.CostBasis,
                    cleanDownRequirement: resObj.CleanDownRequirement,
                    repaymentBasis: resObj.RepaymentBasisTypeId ?? resObj.RepaymentBasis,
                    amortizationYears: resObj.Amortization_Years,
                    sweepPercentage: resObj.SweepPercentage,
                    loanStructureType: resObj.LoanStructureTypeId,
                    portfolioCompany: resObj.PortfolioCompany,
                    lender: resObj.Lender,
                    maturityDate: resObj.MaturityDate ? moment(resObj.MaturityDate) : null,
                    underWritingObjId: resObj?.underWritingModel?.Id,
                    tdsrThresholdvalue: resObj?.underWritingModel?.TdsrThresholdvalue,
                    leverageThresholdvalue: resObj?.underWritingModel?.LeverageThresholdvalue,
                    cbrThresholdvalue: resObj?.underWritingModel?.CbrThresholdvalue,
                    debtIncomeRatioThresholdvalue: resObj?.underWritingModel?.DebtIncomeRatioThresholdvalue,
                    sponserFundModels: resObj.listsponserFundModel || [],
                    funds: loadedFunds.length > 0
                        ? loadedFunds
                        : [{ id: 0, fundName: "", assetClass: undefined, fundSize: "", vintageYear: null }],
                    fundType: loadedFundType,
                    loanOfficers: loadedUsers.filter(u => u.RoleId === 2).map(u => u.UserId),
                    seniorPrivateBankers: loadedUsers.filter(u => u.RoleId === 3).map(u => u.UserId),
                    underwriterBankers: loadedUsers.filter(u => u.RoleId === 4).map(u => u.UserId),
                    privateWealthAdvisors: loadedUsers.filter(u => u.RoleId === 5).map(u => u.UserId),
                    complianceAdministrators: loadedUsers.filter(u => u.RoleId === 8).map(u => u.UserId),
                    applicants: resObj.sponserApplicantModels && resObj.sponserApplicantModels.map((obj) => {
                        return {
                            id: obj.Id,
                            sponserId: obj.SponserId,
                            bankerId: Number(localStorage.getItem("BankerId")),
                            name: obj.ApplicantName,
                            middleName: obj.ApplicantMiddleName,
                            lastName: obj.ApplicantLastName,
                            contactNumber: obj.ApplicantPhone,
                            email: obj.ApplicantEmail,
                            confirmemail: obj.ApplicantEmail,
                            gpCommitment: obj.ProspectiveGPCommitmentAmount
                                ? Number(obj.ProspectiveGPCommitmentAmount)
                                : null,
                            isApplicantRegistered: obj.IsApplicantRegistered,
                            lastEmailSentDateTime: obj.LastEmailSentDateTime,
                            roleId: obj.RoleId,
                            requiresApplication: !!obj.RequiresApplication,
                            selectedFunds: obj.FundsName
                                ? obj.FundsName.split(",").map(x => fundNameToId.get(x.trim())).filter(id => id !== undefined)
                                : []
                        };
                    }),
                });

            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     form.resetFields();
    //     if (sponserData?.applicants?.length > 0) {
    //         const timer = setTimeout(() => {
    //             const current = form.getFieldValue('applicants') || [];
    //             form.setFieldsValue({
    //                 applicants: current.map((app, idx) => ({
    //                     ...app,
    //                     selectedFunds: sponserData.applicants[idx]?.selectedFunds ?? app.selectedFunds ?? [],
    //                 }))
    //             });
    //         }, 0);
    //         return () => clearTimeout(timer);
    //     }
    // }, [sponserData]);

    useEffect(() => {
        form.resetFields();
    }, [sponserData]);

    // antd's field ids are just the name path joined with "_" (same scheme antd's own
    // scrollToField uses internally), so this resolves an error field to the exact node
    // it would scroll to.
    const getFieldDomNode = (namePath) => {
        const id = (Array.isArray(namePath) ? namePath : [namePath]).join('_');
        return document.getElementById(id);
    };

    // errorFields is ordered by field *registration* order, not DOM/visual order: Fund,
    // Underwriting Criteria and Applicants are conditionally rendered/collapsible, so if one
    // of them unmounts and remounts after Assign Internal Stakeholders has already mounted,
    // its fields get re-appended to the end of antd's internal field list even though they
    // render above Assign Internal Stakeholders on the page. Resolve every errored field to
    // its actual DOM node and pick whichever one is first in document order instead, so the
    // topmost invalid field on the page is always the one selected.
    const getFirstInvalidFieldByDomOrder = (errorFields) => {
        const withNodes = errorFields
            .map((errorField) => ({ errorField, node: getFieldDomNode(errorField.name) }))
            .filter((entry) => entry.node);

        if (withNodes.length === 0) {
            return errorFields[0];
        }

        withNodes.sort((a, b) => {
            const position = a.node.compareDocumentPosition(b.node);
            if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
            if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
            return 0;
        });

        return withNodes[0].errorField;
    };

    const onFinishFailed = ({ errorFields }) => {
        if (!errorFields || errorFields.length === 0) return;

        const firstInvalidField = getFirstInvalidFieldByDomOrder(errorFields);

        form.scrollToField(firstInvalidField.name, { behavior: 'smooth', block: 'center' });

        const node = getFieldDomNode(firstInvalidField.name);
        const focusable = node && (node.matches('input, textarea, select, button')
            ? node
            : node.querySelector('input, textarea, select, button, [tabindex]'));
        if (focusable) {
            focusable.focus({ preventScroll: true });
        }
    };

    const onFinish = async (values) => {
        console.log('Form Values:', values);
        const firmAdminsCount =
            (values.applicants || []).filter(app => Number(app.roleId) === 6).length;

        if (firmAdminsCount === 0) {
            message.error("At least one Firm Admin is required.");
            setLoading(false);
            return;
        }

        if (firmAdminsCount > 1) {
            message.error("Only one applicant can be assigned the Firm Admin role.");
            setLoading(false);
            return;
        }

        const listsponserFundModel = (values.funds || []).map((fund) => ({
            Id: fund.id || 0,
            SponserId: sponserId || 0,
            FundName: fund.fundName?.trim() || "",
            Fund: values.fundType === "multi" ? "multifund" : "singlefund",

            AssetClassTypeId: fund.assetClass || null,
            FundValue: Number(String(fund.fundSize || "").replace(/[^0-9.]/g, "")) || 0,
            VintageYear: fund.vintageYear ? moment(fund.vintageYear).format("MM/YYYY") : null,
            CreatedBy: Number(localStorage.getItem("BankerId")),
            UpdatedBy: Number(localStorage.getItem("BankerId")),
        }));
        console.log("listsponserFundModel.", listsponserFundModel);
        const fundIdToName = new Map((values.funds || []).map((fund) => [fund.id, fund.fundName?.trim() || ""]));
        const allUserOptions = [
            ...loanOfficerOptions.map(u => ({ ...u, roleId: 2 })),
            ...seniorPrivateBankerOptions.map(u => ({ ...u, roleId: 3 })),
            ...underwriterBankerOptions.map(u => ({ ...u, roleId: 4 })),
            ...privateWealthAdvisorOptions.map(u => ({ ...u, roleId: 5 })),
            ...complianceAdminOptions.map(u => ({ ...u, roleId: 8 })),
        ];
        const selectedUserGroups = [
            { roleId: 2, ids: values.loanOfficers || [] },
            { roleId: 3, ids: values.seniorPrivateBankers || [] },
            { roleId: 4, ids: values.underwriterBankers || [] },
            { roleId: 5, ids: values.privateWealthAdvisors || [] },
            { roleId: 8, ids: values.complianceAdministrators || [] },
        ];
        const listSponserUsersModel = selectedUserGroups.flatMap(({ roleId, ids }) =>
            ids.map(userId => {
                const existing = existingSponserUsers.find(u => u.UserId === userId && u.RoleId === roleId);
                const userInfo = allUserOptions.find(u => u.Id === userId && u.roleId === roleId);
                return {
                    id: existing ? existing.Id : 0,
                    userId,
                    email: userInfo ? userInfo.Email : "",
                    roleId,
                };
            })
        );
        console.log("listSponserUsersModel.", listSponserUsersModel);
        setLoading(true);

        const selectedCorporateRepaymentBasis = corporateRepaymentBasisOptions.find(
            (item) => item.Id === values.repaymentBasis
        );

        const selectedTypeOfBusiness = typeOfBusinessOptions.find(
            (item) => item.Id === values.typeOfBusiness
        );

        const isAddingNewFirm = values.firm === ADD_NEW_FIRM;
        const selectedFirm = !isAddingNewFirm ? firmMasterOptions.find((f) => f.Id === values.firm) : null;

        let reqObj = {
            "Id": sponserId || 0,
            "FirmId": isAddingNewFirm ? null : values.firm,
            "CompanyName": isAddingNewFirm ? values.newFirmName?.trim() : (selectedFirm?.FirmName ?? values.newFirmName),
            "Institution": values.institution,
            "ContactNumber": values.businessPhone,
            "TypeOfBusiness": selectedTypeOfBusiness?.Name,
            "BusinessTypeId": selectedTypeOfBusiness?.Id,
            "YearsAssociated": values.yearsAssociated,
            "TotalProgrameSize": values.TotalProgrameSize,
            "AdvanceRate": values.AdvanceRate,
            "TaxRate": values.TaxRate,
            "MaxLTV": values.MaxLTV,
            "IntrestExpense": values.interestRate,
            "CommitmentFee": values.commitmentFee,
            "Tenor_Years": values.tenorYears,
            "Tenor_Other": values.tenorYears === "Demand" ? values.tenorOther : null,
            "Security": values.security,
            "GuranterName": values.security === "Guaranteed" ? values.guarantorName : null,
            "UncalledCapital": values.uncalledCapital,
            "CostBasis": values.costBasis,
            "CleanDownRequirement": values.cleanDownRequirement,
            "RepaymentBasis": selectedCorporateRepaymentBasis?.Name,
            "RepaymentBasisTypeId": selectedCorporateRepaymentBasis?.Id,
            "Amortization_Years": selectedCorporateRepaymentBasis?.Name === "Amortization" ? values.amortizationYears : null,
            "SweepPercentage": values.sweepPercentage,
            "LoanStructureTypeId": values.loanStructureType,
            "PortfolioCompany": values.portfolioCompany,
            "Lender": values.lender,
            "MaturityDate": values.maturityDate ? moment(values.maturityDate).format("YYYY-MM-DD") : null,

            "LoanProgrameTypeId": values.creditFacility,
            "CreditFacilityName": values.creditFacilityName?.trim(),
            // "AssetClassTypeId": values.assetClass,
            // "Fund": values.fund,
            // // "Vintage": values.vintage,
            // "Vintage": values.vintage ? moment(values.vintage).format("YYYY-MM-DD") : null,

            "listsponserFundModel": listsponserFundModel,
            "StreetAddress": values.streetAddress,
            "City": values.city,
            "State": values.state,
            "ZipCode": values.zip,
            "BankerId": Number(localStorage.getItem("BankerId")),
            "underWritingModel": {
                "Id": sponserData && sponserData.underWritingObjId > 0 ? sponserData.underWritingObjId : 0,
                "TdsrThresholdvalue": values.tdsrThresholdvalue,
                "LeverageThresholdvalue": values.leverageThresholdvalue,
                "CbrThresholdvalue": values.cbrThresholdvalue,
                "DebtIncomeRatioThresholdvalue": values.debtIncomeRatioThresholdvalue,
            },
            "sponserApplicantModels": values.applicants && values.applicants.map((obj) => {
                return {
                    Id: obj.id || 0,
                    SponserId: sponserId > 0 ? sponserId : 0,
                    BankerId: Number(localStorage.getItem("BankerId")),
                    ApplicantName: obj.name,
                    ApplicantMiddleName: obj.middleName,
                    ApplicantLastName: obj.lastName,
                    ApplicantPhone: obj.contactNumber,
                    ApplicantEmail: obj.email,
                    ProspectiveGPCommitmentAmount: obj.gpCommitment,
                    RoleId: obj.roleId ? obj.roleId : 7,
                    RequiresApplication: obj.roleId === 6 ? !!obj.requiresApplication : null,
                    Funds: (obj.selectedFunds || []).map(id => fundIdToName.get(id)).filter(Boolean).join(",")
                    // IntrestExpense: obj.interestExpense
                };
            }),
            "listSponserUsersModel": listSponserUsersModel,
            "listSponserReportingRequirementModel": reportingRequirements.map((item) => ({
                Id: item.Id > 0 ? item.Id : 0,
                DocumentTypeId: item.DocumentTypeId,
                FirstDueDate: item.FirstDueDate,
                CadenceDays: item.CadenceDays,
                TestedMetric: item.TestedMetric,
                Operator: item.Operator,
                ThresholdValue: item.ThresholdValue,
            })),
            "deletedReportingRequirementIds": deletedReportingRequirementIds,
        }

        const emails = values.applicants?.map(app => app.email?.toLowerCase().trim()) || [];
        const duplicateEmails = emails.filter((email, index) => emails.indexOf(email) !== index);

        if (duplicateEmails.length > 0) {
            const uniqueDuplicates = [...new Set(duplicateEmails)];
            message.error(`Duplicate Client Email(s) found: ${uniqueDuplicates.join(', ')}`);
            setLoading(false);
            return;
        }

        try {
            const res = await _BankerService.addUpdateSponser(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                history.push({ pathname: routes.sponsors.path });
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
        finally {
            setLoading(false);
        }
    };

    const onBack = () => {
        // Facility Details reads firmId/companyName from location.state to know which firm's
        // facilities to load -- without it, it can't tell it's being returned to and redirects
        // straight to the Credit Facility Dashboard instead. Carry those over from the loaded
        // sponser record so Back actually lands back on Facility Details.
        history.push({
            pathname: routes.facilityDetails.path,
            state: { firmId: sponserData?.FirmId, companyName: sponserData?.CompanyName },
        });
    }

    // console.log("sponserData++", sponserData);
    // console.log("applicants--", form.getFieldValue('applicants'));
    // console.log("A", sponserData && sponserData.applicants && sponserData.applicants.length == 0);
    // console.log("B", form.getFieldValue('applicants') && form.getFieldValue('applicants').length == 0);          


    const handleDeleteApplicant = (field, remove, form, index) => {
        const applicants = form.getFieldValue('applicants');
        const applicant = applicants?.[field.name];

        confirm({
            title: <span>Are you sure you want to delete this Client <Text className='f16' strong>{applicant && applicant.email ? `(${applicant.email})` : ""}</Text>?</span>,
            icon: <ExclamationCircleOutlined />,
            width: 500,
            okText: <span id="yesBtn">Yes</span>,
            cancelText: <span id="noBtn">No</span>,
            okType: "primary",
            async onOk() {
                if (applicant?.id && applicant.id > 0) {
                    // This record exists in DB → call delete API
                    try {
                        setLoading(true);
                        const res = await _BankerService.deleteSponserApplicantById(applicant.id);
                        if (res.data.IsSuccess) {
                            message.success(res.data.Message || 'Client deleted successfully');
                            remove(field.name);
                            getSponserDataBySponserId(sponserId);
                        } else {
                            message.error(res.data.Message || COMMON_ERROR_MSG);
                            setLoading(false);
                        }
                    } catch (error) {
                        console.log(error);
                        setLoading(false);
                    } finally {
                        setLoading(false);
                    }
                } else {
                    // New unsaved record → just remove from form
                    remove(index);
                }
            }
        });
    };

    const handleResendEmailOTP = (field, form) => {
        const applicants = form.getFieldValue('applicants');
        const applicant = applicants?.[field.name];

        confirm({
            title: <span>Are you sure you want to resend the OTP to this applicant's email <Text className='f16' strong>{applicant && applicant.email ? `(${applicant.email})` : ""}</Text>?</span>,
            icon: <ExclamationCircleOutlined />,
            width: 500,
            okText: <span id="yesBtn">Yes</span>,
            cancelText: <span id="noBtn">No</span>,
            okType: "primary",
            async onOk() {
                if (applicant?.id && applicant.id > 0) {

                    const reqObj =
                    {
                        "Id": applicant.id,
                        "ApplicantName": applicant.name,
                        "ApplicantMiddleName": applicant.middleName,
                        "ApplicantLastName": applicant.lastName,
                        "ApplicantPhone": applicant.contactNumber,
                        "ApplicantEmail": applicant.email,
                        "ProspectiveGPCommitmentAmount": applicant.gpCommitment,
                        "RoleId": applicant.roleId,
                        // "IntrestExpense": applicant.interestExpense,
                        "BankerId": applicant.bankerId || Number(localStorage.getItem("BankerId")),
                        "SponserId": applicant.sponserId || sponserId
                    }

                    try {
                        setLoading(true);
                        const res = await _BankerService.resendApplicantEmailOTP(reqObj);
                        if (res.data.IsSuccess) {
                            message.success(res.data.Message || 'OTP sent successfully');
                            getSponserDataBySponserId(sponserId);
                        } else {
                            message.error(res.data.Message || COMMON_ERROR_MSG);
                            setLoading(false);
                        }
                    } catch (error) {
                        console.log(error);
                        setLoading(false);
                    } finally {
                        setLoading(false);
                    }
                }
            }
        });
    };


    // const onUnderWriteBtnClick = () => {
    //     history.push({
    //         pathname: routes.applicantUnderwritingCriteria.path,
    //         state: { sponserId: sponserId },
    //     });
    // }

    const isAnyApplicantEmpty = () => {
        const applicants = form.getFieldValue('applicants') || [];

        return applicants.some(app => {
            return (
                (app?.name || "").trim() === "" &&
                (app?.contactNumber || "").trim() === "" &&
                (app?.email || "").trim() === "" &&
                (app?.gpCommitment === null || app?.gpCommitment === "")
                // (app?.interestExpense === null || app?.interestExpense === "")
            );
        });
    };

    const handleSaveApplicant = async () => {
        const applicants = form.getFieldValue('applicants') || [];
        const fieldNames = applicants.flatMap((_, idx) => [
            ['applicants', idx, 'name'],
            ['applicants', idx, 'email'],
            ['applicants', idx, 'confirmemail'],
            ['applicants', idx, 'contactNumber'],
            ['applicants', idx, 'gpCommitment'],
            ['applicants', idx, 'roleId'],
            ['applicants', idx, 'selectedFunds'],
        ]);

        try {
            await form.validateFields(fieldNames);
        } catch {
            return;
        }

        const values = form.getFieldsValue();
        const fundIdToName = new Map((values.funds || []).map((fund) => [fund.id, fund.fundName?.trim() || ""]));
        const reqObj = {
            sponserApplicantModels: (values.applicants || []).map((obj) => ({
                Id: obj.id || 0,
                SponserId: sponserId > 0 ? sponserId : 0,
                BankerId: Number(localStorage.getItem("BankerId")),
                ApplicantName: obj.name,
                ApplicantMiddleName: obj.middleName,
                ApplicantLastName: obj.lastName,
                ApplicantPhone: obj.contactNumber,
                ApplicantEmail: obj.email,
                ProspectiveGPCommitmentAmount: obj.gpCommitment,
                RoleId: obj.roleId ? obj.roleId : 7,
                RequiresApplication: obj.roleId === 6 ? !!obj.requiresApplication : null,
                Funds: (obj.selectedFunds || []).map(id => fundIdToName.get(id)).filter(Boolean).join(","),
            })),
        };

        setLoading(true);
        try {
            const res = await _BankerService.saveSponserApplicant(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.log(err);
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };

    // const handleCollapseChange = (key) => {
    //     const isCollapsing = activePanelKey.includes('1');
    //     if (addClickedRef.current) {
    //         addClickedRef.current = false;
    //         setActivePanelKey(key);
    //         return;
    //     }

    //     if (isCollapsing && isAnyApplicantEmpty()) {
    //         message.warning("Please complete all fields for each applicant or remove empty applicants");
    //         return;
    //     }
    //     setActivePanelKey(key);
    // };

    // ✅ Function to handle role change
    const handleRoleChange = (e, field, form) => {
        const checked = e.target.checked;
        const applicants = form.getFieldValue("applicants") || [];

        if (checked) {
            const alreadyExists = applicants.some(
                (app, idx) => idx !== field.name && Number(app.roleId) === 6
            );

            if (alreadyExists) {
                message.error("Only one Firm Admin can be selected.");
                return;
            }

            applicants[field.name] = {
                ...applicants[field.name],
                roleId: 6,
            };
        } else {
            applicants[field.name] = {
                ...applicants[field.name],
                roleId: undefined,
            };
        }

        form.setFieldsValue({ applicants });
    };

    // Clears whatever the "Existing Firm Admin" checkbox autofilled into applicants[0]. Used both when
    // the checkbox itself is unchecked, and when the Credit Facility type changes (which can flip
    // whether the first participant's role is force-locked to Firm Administrator or freely editable).
    const clearExistingFirmAdminAutofill = (form, keepFirmAdminRole) => {
        const applicants = form.getFieldValue('applicants') || [];
        if (applicants.length === 0) {
            return;
        }
        const updatedApplicants = [...applicants];
        updatedApplicants[0] = {
            ...updatedApplicants[0],
            name: "",
            middleName: "",
            lastName: "",
            email: "",
            confirmemail: "",
            contactNumber: "",
            gpCommitment: "",
            roleId: keepFirmAdminRole ? 6 : undefined,
        };
        form.setFieldsValue({ applicants: updatedApplicants });
    };

    // "Existing Firm Admin" autofill checkbox (first participant only, existing firm only): looks up
    // the firm's existing Firm Administrator (if any) and patches applicants[0], mirroring the same
    // form.setFieldsValue idiom handleRoleChange and the Firm Name dropdown's onChange already use.
    const handleExistingFirmAdminChange = async (e, form) => {
        const checked = e.target.checked;
        setExistingFirmAdminChecked(checked);
        if (!checked) {
            clearExistingFirmAdminAutofill(form, isCorporateLoanProgram || isSubscriptionLineOfCredit);
            return;
        }
        const firmId = form.getFieldValue('firm');
        if (!firmId || firmId === ADD_NEW_FIRM) {
            return;
        }
        try {
            setLoading(true);
            const res = await _BankerService.getExistingFirmAdminByFirmId(firmId);
            if (res.data.IsSuccess && res.data.Obj) {
                const firmAdmin = res.data.Obj;
                const applicants = form.getFieldValue('applicants') || [];
                const updatedApplicants = [...applicants];
                updatedApplicants[0] = {
                    ...updatedApplicants[0],
                    name: firmAdmin.ApplicantName,
                    middleName: firmAdmin.ApplicantMiddleName,
                    lastName: firmAdmin.ApplicantLastName,
                    email: firmAdmin.ApplicantEmail,
                    confirmemail: firmAdmin.ApplicantEmail,
                    contactNumber: firmAdmin.ApplicantPhone,
                    gpCommitment: firmAdmin.ProspectiveGPCommitmentAmount,
                    roleId: 6,
                };
                form.setFieldsValue({ applicants: updatedApplicants });
            } else {
                message.info("No existing Firm Administrator found for this firm");
            }
        } catch (error) {
            console.log(error);
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };



    console.log(creditFacilityValue, "creditFacilityValue")

    const selectedLoanProgramName = loanProgramOptions.find((item) => item.Id === creditFacilityValue)?.Name;
    const isSubscriptionLineOfCredit = selectedLoanProgramName === "Subscription Line of Credit";
    const isCorporateLoanProgram = selectedLoanProgramName === "Corporate Loan";
    const isLoanProgram = selectedLoanProgramName === "Loan Program";
    const isCustomIndividualFinancing = selectedLoanProgramName === "Custom Individual Financing";
    const showUnderwritingCriteriaSection = isLoanProgram || isCustomIndividualFinancing;
    const showSweepPercentage = !isSubscriptionLineOfCredit
        && (!isCorporateLoanProgram || repaymentBasisNameValue === "Cash Flow Sweep")
        && !((isLoanProgram || isCustomIndividualFinancing) && repaymentBasisNameValue === "Amortization");
    const showUnderwritingAndParticipantSections = !isSubscriptionLineOfCredit && !isCorporateLoanProgram;
    const selectedTypeOfBusinessName = typeOfBusinessOptions.find((item) => item.Id === typeOfBusinessValue)?.Name;
    const isSponsorTypeOfBusiness = selectedTypeOfBusinessName === "Sponsor";
    const showFundSection = !isCorporateLoanProgram && (!isLoanProgram || isSponsorTypeOfBusiness);
    const isLawFirmTypeOfBusiness = selectedTypeOfBusinessName === "Law Firm";
    // Fund section stays visible but its fields become optional for a Law Firm sponsor
    // on a Custom Individual Financing credit facility.
    const isFundSectionOptional = isLawFirmTypeOfBusiness && isCustomIndividualFinancing;

    return (
        <>
            {loading && createPortal(
                <div className="viewport-centered-spinner">
                    <Spin size="large" />
                </div>,
                document.body
            )}
            <Spin spinning={loading} className="page-loading-spin">
                <SidebarLayout>
                <div className='baseAlign' style={{ justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                    <Title level={3} className='page-title' style={{ marginBottom: 0 }}>{sponserId > 0 ? "Edit" : "Add"} Credit Facility</Title>

                    <Space align="center">
                        <Button
                            className="back-btn"
                            icon={<LeftOutlined />}
                            onClick={onBack}
                        >
                            Back
                        </Button>

                        {sponserId && (sponserId > 0) ?
                            <ButtonComponent
                                type='primary'
                                onClick={showModal}
                                text={"Delete Credit facility"}
                                icon={<DeleteOutlined />}
                            /> :
                            <></>
                        }
                    </Space>
                </div>
                <Card className='add-edit-sponsers'>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        initialValues={sponserData}
                        className='inputDisabledBlackColor'
                    >
                        <Row gutter={[16, 16]}>
                            <Col
                                className="gutter-row"
                                xs={{ span: 24 }}
                                lg={{ span: 24 }}
                                md={{ span: 24 }}
                                sm={sponserId && sponserId > 0 ? { span: 16 } : { span: 24 }}
                                xl={sponserId && sponserId > 0 ? { span: 16 } : { span: 24 }}
                            >
                                <div className='card-section'>
                                    <Title level={5} className='form-title' >Firm Details</Title>
                                    <Row gutter={[16, 16]}>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Firm Name"
                                                name="firm"
                                                rules={[
                                                    { required: true, message: "Firm Name is required" },
                                                ]}
                                            >
                                                <Select
                                                    size="large"
                                                    className="firm-name-select"
                                                    placeholder="Search Firm Name"
                                                    showSearch
                                                    filterOption={false}
                                                    notFoundContent={
                                                        firmSearchLoading
                                                            ? <Spin size="small" />
                                                            : firmSearchTerm.trim().length < FIRM_SEARCH_MIN_CHARS
                                                                ? `Type at least ${FIRM_SEARCH_MIN_CHARS} characters to search`
                                                                : "No Firm Found"
                                                    }
                                                    onSearch={handleFirmSearch}
                                                    allowClear
                                                    disabled={sponserId > 0}
                                                    onKeyUp={(e) => {
                                                        // Let Backspace/Delete clear the current selection too, not just the "x"
                                                        // icon -- once the search text is fully erased, drop the selected firm.
                                                        if ((e.key === "Backspace" || e.key === "Delete") && e.target.value === "") {
                                                            const currentFirm = form.getFieldValue("firm");
                                                            if (currentFirm !== undefined && currentFirm !== ADD_NEW_FIRM) {
                                                                form.setFieldsValue({ firm: undefined });
                                                                clearSelectedFirm();
                                                            }
                                                        }
                                                    }}
                                                    onChange={(value) => {
                                                        if (value === undefined) {
                                                            clearSelectedFirm();
                                                        } else if (value === ADD_NEW_FIRM) {
                                                            setShowAddNewFirm(true);
                                                            setIsExistingFirmSelected(false);
                                                            form.setFieldsValue({
                                                                newFirmName: "",
                                                                typeOfBusiness: undefined,
                                                                businessPhone: "",
                                                                streetAddress: undefined,
                                                                city: undefined,
                                                                state: undefined,
                                                                zip: undefined,
                                                            });
                                                            setTypeOfBusinessValue(undefined);
                                                            if (!(sponserId > 0)) {
                                                                getActualTenantName();
                                                            }
                                                        } else {
                                                            setShowAddNewFirm(false);
                                                            const matched = firmMasterOptions.find((f) => f.Id === value);
                                                            if (matched) {
                                                                setIsExistingFirmSelected(true);
                                                                form.setFieldsValue({
                                                                    newFirmName: undefined,
                                                                    typeOfBusiness: matched.BusinessTypeId || undefined,
                                                                    institution: matched.Institution,
                                                                    businessPhone: matched.ContactNumber,
                                                                    streetAddress: matched.StreetAddress,
                                                                    city: matched.City,
                                                                    state: matched.State,
                                                                    zip: matched.ZipCode,
                                                                });
                                                                setTypeOfBusinessValue(matched.BusinessTypeId || undefined);
                                                                applyBusinessTypeSideEffects(matched.BusinessTypeId);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    {firmMasterOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.FirmName}
                                                        </Select.Option>
                                                    ))}
                                                    <Select.Option key={ADD_NEW_FIRM} value={ADD_NEW_FIRM}>
                                                        + Add New Firm
                                                    </Select.Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        {showAddNewFirm && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <FormItemInput
                                                    label="New Firm Name"
                                                    name="newFirmName"
                                                    placeholder="Enter New Firm Name"
                                                    rules={[
                                                        { required: true, message: "New Firm Name is required" },
                                                    ]}
                                                />
                                            </Col>
                                        )}
                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Type Of Business"
                                                name="typeOfBusiness"
                                                rules={[
                                                    { required: true, message: "Type Of Business is required" },
                                                ]}
                                            >
                                                <Select
                                                    size="large"
                                                    placeholder="Select Type Of Business"
                                                    onChange={(value) => {
                                                        setTypeOfBusinessValue(value);
                                                        applyBusinessTypeSideEffects(value);
                                                    }}
                                                >
                                                    {typeOfBusinessOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.Name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <FormItemInput
                                                label="Institution"
                                                name="institution"
                                                placeholder="Enter Institution"
                                                rules={[
                                                    { required: true, message: "institution is required" },
                                                ]}
                                                disabled
                                            />
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <FormItemPhoneNumber
                                                label="Business Phone"
                                                name="businessPhone"
                                                form={form}
                                                placeholder="Enter Business Phone"
                                                rules={[
                                                    { required: true, message: "Business Phone is required" },
                                                ]}
                                                disabled={isExistingFirmSelected}
                                            />

                                        </Col>





                                        {/* <Col
                                className="gutter-row"
                                xs={{ span: 24 }}
                                lg={{ span: 24 }}
                                md={{ span: 24 }}
                                sm={{ span: 12 }}
                                xl={{ span: 12 }}
                            >
                                <Form.Item
                                    label="Years Associated"
                                    name="yearsAssociated"
                                    rules={[{ required: true, message: 'Years Associated is required' }]}
                                >
                                    <IntegerInput
                                        placeholder="Enter Years Associated"
                                    // disabled={sponserId && sponserId > 0 ? true : false}
                                    />
                                </Form.Item>
                            </Col> */}

                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <FormItemCurrencyInput
                                                label="Total Program Size $"
                                                name="TotalProgrameSize"
                                                placeholder="Enter Total Program Size"
                                                rules={[
                                                    { required: true, message: "Total Program Size is required" },
                                                ]}
                                            />

                                        </Col>
                                        {!isCorporateLoanProgram && (
                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <FormItemIntegerInput
                                                label="Advance Rate %"
                                                name="AdvanceRate"
                                                placeholder="Enter Advance Rate"
                                                maxLength={3}
                                                rules={[
                                                    { required: true, message: "Advance Rate is required" },
                                                    {
                                                        validator: (_, value) => {
                                                            if (
                                                                !value ||
                                                                (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)
                                                            ) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(
                                                                new Error("Enter a valid 3-digit number (0-999)")
                                                            );
                                                        },
                                                    },
                                                ]}
                                            />
                                        </Col> */}

                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                 

                                            <FormItemIntegerInput
                                                label="Max LTV %"
                                                name="MaxLTV"
                                                placeholder="Enter Max LTV"
                                                maxLength={3}
                                                rules={[
                                                    { required: true, message: "Max LTV is required" },
                                                    {
                                                        validator: (_, value) => {
                                                            if (!value || (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error('Enter a valid 3-digit number (0-999)'));
                                                        },
                                                    },
                                                ]}
                                            />
                                        </Col> */}

                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                         
                                            <FormItemDecimalInput
                                                label="Interest Rate %"
                                                name="interestRate"
                                                placeholder="Enter Interest Rate"
                                                maxLength={5}
                                                rules={[
                                                    { required: true, message: 'Interest Rate is required' }
                                                ]}
                                            />

                                        </Col> */}


                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            {/* <Form.Item
                                    label="Street Address"
                                    name="streetAddress"
                                    rules={[{ required: true, message: 'Street Address is required' }]}
                                >
                                    <Input
                                        placeholder='Enter Street Address'
                                    // disabled={sponserId && sponserId > 0 ? true : false}

                                    />
                                </Form.Item> */}
                                            <FormItemInput
                                                label="Street Address"
                                                name="streetAddress"
                                                placeholder="Enter Street Address"
                                                rules={[
                                                    { required: true, message: "Street Address is required" },
                                                ]}
                                                disabled={isExistingFirmSelected}
                                            />
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            {/* <Form.Item
                                    label="City"
                                    name="city"
                                    rules={[{ required: true, message: 'City is required' }]}
                                >
                                    <Input
                                        placeholder='Enter City'
                                    // disabled={sponserId && sponserId > 0 ? true : false}

                                    />
                                </Form.Item> */}

                                            <FormItemInput
                                                label="City"
                                                name="city"
                                                placeholder="Enter City"
                                                rules={[
                                                    { required: true, message: "City is required" },
                                                ]}
                                                disabled={isExistingFirmSelected}
                                            />
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            {/* <Form.Item
                                    label="State"
                                    name="state"
                                    rules={[{ required: true, message: 'State is required' }]}
                                >
                                    <Input
                                        placeholder='Enter State'
                                    // disabled={sponserId && sponserId > 0 ? true : false}

                                    />
                                </Form.Item> */}

                                            <FormItemInput
                                                label="State"
                                                name="state"
                                                placeholder="Enter State"
                                                rules={[
                                                    { required: true, message: "State is required" },
                                                ]}
                                                disabled={isExistingFirmSelected}
                                            />
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            {/* <Form.Item
                                    label="Zip Code"
                                    name="zip"
                                    rules={[{ required: true, message: 'Zip Code is required' }]}
                                >
                                    <IntegerInput
                                        placeholder='Enter Zip Code'
                                        maxLength={20}
                                    // disabled={sponserId && sponserId > 0 ? true : false}
                                    />
                                </Form.Item> */}

                                            <Form.Item
                                                label="Zip Code"
                                                name="zip"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Zip Code is required',
                                                    },
                                                    {
                                                        pattern: /^\d{5}(-\d{4})?$/,
                                                        message: 'Enter a valid ZIP Code (e.g., 12345 or 12345-6789)',
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder="Enter Zip Code"
                                                    maxLength={10} // Supports 12345-6789
                                                    disabled={isExistingFirmSelected}
                                                />
                                            </Form.Item>
                                        </Col>
                                        {/* <Col xs={24} sm={12} xl={12}>
                                            <Form.Item
                                                label="Credit Facility"
                                                name="creditFacility"
                                                rules={[{ required: true, message: "Credit Facility is required" }]}


                                            >
                                                <Select
                                                    size="large"
                                                    placeholder="Select Credit Facility"
                                                    onChange={(value) => {
                                                        setCreditFacilityValue(value);
                                                        setRepaymentBasisNameValue(undefined);
                                                        form.setFieldsValue({ repaymentBasis: undefined, amortizationYears: undefined });
                                                    }}
                                                    disabled={sponserId > 0}
                                                >
                                                    {loanProgramOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.Name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col> */}

                                        {/* <Col xs={24} sm={12} xl={12}>
                                            <Form.Item
                                                label="Repayment Basis"
                                                name="repaymentBasis"
                                                rules={[{ required: true, message: "Repayment Basis is required" }]}
                                            >
                                                <Select
                                                    size="large"
                                                    placeholder="Select Repayment Basis"
                                                >
                                                    {(loanProgramOptions.find((item) => item.Id === creditFacilityValue)?.Name === "Corporate Loan")
                                                        ? corporateRepaymentBasisOptions.map((item) => (
                                                            <Select.Option key={item.Id} value={item.Id}>
                                                                {item.Name}
                                                            </Select.Option>
                                                        ))
                                                        : repaymentBasisOptions.map((item) => (
                                                            <Select.Option key={item.value} value={item.value}>
                                                                {item.label}
                                                            </Select.Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col> */}

                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <FormItemIntegerInput
                                                label="Sweep %"
                                                name="sweepPercentage"
                                                placeholder="Enter Sweep %"
                                                maxLength={3}
                                                rules={[
                                                    { required: true, message: "Sweep % is required" },
                                                    {
                                                        validator: (_, value) => {
                                                            if (!value) return Promise.resolve();
                                                            const num = parseInt(value, 10);
                                                            if (/^\d{1,3}$/.test(value) && num >= 50 && num <= 100) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error("Sweep % must be between 50 and 100"));
                                                        },
                                                    },
                                                ]}
                                            />
                                        </Col> */}

                                        {/* <Col xs={24} sm={12} xl={12} className='H50'>
                                            <Form.Item
                                                label="Asset Class"
                                                name="assetClass"
                                                rules={[{ required: true, message: "Asset Class is required" }]}

                                            >
                                                <Select
                                                    size="large"
                                                    placeholder="Select Asset Class">
                                                    {assetClassOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.Name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col> */}
                                        {/* Fund Type Toggle */}
                                        {/* <Col xs={24}>
                                            <Form.Item
                                                label="Fund"
                                                name="fundType"
                                                rules={[{ required: true, message: "Fund type is required" }]}
                                            >
                                                <Radio.Group
                                                    optionType="button"
                                                    buttonStyle="solid"
                                                    className="fund-type-toggle"
                                                    disabled={sponserId > 0}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        setFundType(val);
                                                        if (val === "single") {
                                                            const existing = form.getFieldValue("funds") || [];
                                                            form.setFieldsValue({
                                                                funds: [existing[0] || { id: 0, fundName: "", assetClass: undefined, fundSize: "", vintageYear: null }],
                                                            });
                                                        }
                                                    }}
                                                >
                                                    <Radio.Button value="single">Single Fund</Radio.Button>
                                                    <Radio.Button value="multi">Multi Fund</Radio.Button>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col> */}

                                        {/* Dynamic Fund Rows */}
                                        {/* <Col xs={24}>
                                            <Form.List name="funds">
                                                {(fundFields, { add: addFund, remove: removeFund }) => (
                                                    <>
                                                        {fundFields.map((fundField, fundIndex) => (
                                                            // <Row gutter={[16, 0]} key={fundField.key} align="top" style={{ marginBottom: fundType === "multi" ? 30 : 0 }}>
                                                            <Row gutter={[16, 0]} key={fundField.key} align="top" className="fund-fields-row" style={{ marginBottom: fundType === "multi" ? 30 : 0 }}>
                                                                <Col xs={24} sm={12} xl={5}>
                                                                    <Form.Item
                                                                        {...fundField}
                                                                        label="Fund Name"
                                                                        name={[fundField.name, "fundName"]}
                                                                        rules={[
                                                                            { required: true, message: "Fund Name is required" },
                                                                            { pattern: /^[a-zA-Z\s]+$/, message: "Only letters allowed" },
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const trimmed = (value || "").trim().toLowerCase();
                                                                                    if (!trimmed) return Promise.resolve();
                                                                                    const funds = form.getFieldValue("funds") || [];
                                                                                    const isDuplicate = funds.some(
                                                                                        (f, idx) => idx !== fundField.name && (f?.fundName || "").trim().toLowerCase() === trimmed
                                                                                    );
                                                                                    return isDuplicate
                                                                                        ? Promise.reject(new Error("Fund Name already exists"))
                                                                                        : Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Input size="large" placeholder="Enter Fund Name" />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col xs={24} sm={12} xl={4}>
                                                                    <Form.Item
                                                                        {...fundField}
                                                                        label="Fund Size $"
                                                                        name={[fundField.name, "fundSize"]}
                                                                        rules={[{ required: true, message: "Fund Size is required" }]}
                                                                    >
                                                                        <CurrencyInput
                                                                            size="large"
                                                                            placeholder="Enter Fund Size"
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={12} xl={4}>
                                                                    <Form.Item
                                                                        {...fundField}
                                                                        label="Vintage Year"
                                                                        name={[fundField.name, "vintageYear"]}
                                                                        rules={[{ required: true, message: "Vintage Year is required" }]}
                                                                    >
                                                                        <DatePicker
                                                                            size="large"
                                                                            picker="month"
                                                                            format="MM/YYYY"
                                                                            placeholder="MM/YYYY"
                                                                            style={{ width: "100%", height: "50px" }}
                                                                            disabledDate={(current) => current && current.isAfter(moment(), 'month')}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={12} xl={5}>
                                                                    <Form.Item
                                                                        {...fundField}
                                                                        label="Asset Class"
                                                                        name={[fundField.name, "assetClass"]}
                                                                        rules={[{ required: true, message: "Asset Class is required" }]}
                                                                    >
                                                                        <Select size="large" placeholder="Select Asset Class">
                                                                            {assetClassOptions.map(item => (
                                                                                <Select.Option key={item.Id} value={item.Id}>{item.Name}</Select.Option>
                                                                            ))}
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>
                                                                {fundType === "multi" && (
                                                                    <Col xs={24} xl={6}>
                                                                        <Form.Item label=" ">
                                                                            <Space>
                                                                                {fundFields.length > 1 && (
                                                                                    <Button
                                                                                        size="large"
                                                                                        type="text"
                                                                                        icon={<DeleteOutlined />}
                                                                                        onClick={() => {
                                                                                            const funds = form.getFieldValue("funds") || [];
                                                                                            const fundId = funds[fundField.name]?.id;
                                                                                            const applicants = form.getFieldValue("applicants") || [];
                                                                                            const isLinked = (fundId !== undefined && fundId !== null) && applicants.some(
                                                                                                app => (app?.selectedFunds || []).includes(fundId)
                                                                                            );
                                                                                            if (isLinked) {
                                                                                                message.error("Fund deletion is not allowed. The selected fund is linked with an applicant.");
                                                                                                return;
                                                                                            }
                                                                                            removeFund(fundField.name);
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                                {fundIndex === fundFields.length - 1 && (
                                                                                    <ButtonComponent
                                                                                        type="primary"
                                                                                        size="large"
                                                                                        icon={<PlusOutlined />}
                                                                                        onClick={() => addFund({ id: -Date.now(), fundName: "", assetClass: undefined, fundSize: "", vintageYear: null })}
                                                                                        text={<span><PlusOutlined /> Add Fund</span>}
                                                                                    />
                                                                                )}
                                                                            </Space>
                                                                        </Form.Item>
                                                                    </Col>
                                                                )}
                                                            </Row>
                                                        ))}
                                                    </>
                                                )}
                                            </Form.List>
                                        </Col> */}


                                    </Row>
                                </div>

                                <div className='card-section'>
                                    <Title level={5} className='form-title' > Credit Facility Terms</Title>
                                    <Row gutter={[16, 16]}>

                                        <Col xs={24} sm={12} xl={12}>
                                            <Form.Item
                                                label="Credit Facility"
                                                name="creditFacility"
                                                rules={[{ required: true, message: "Credit Facility is required" }]}


                                            >
                                                <Select
                                                    size="large"
                                                    placeholder="Select Credit Facility"
                                                    onChange={(value) => {
                                                        setCreditFacilityValue(value);
                                                        if (existingFirmAdminChecked) {
                                                            setExistingFirmAdminChecked(false);
                                                            const newLoanProgramName = loanProgramOptions.find((item) => item.Id === value)?.Name;
                                                            const newIsFirmAdminLocked = newLoanProgramName === "Corporate Loan" || newLoanProgramName === "Subscription Line of Credit";
                                                            clearExistingFirmAdminAutofill(form, newIsFirmAdminLocked);
                                                        }
                                                        setRepaymentBasisNameValue(undefined);
                                                        setTenorYearsValue(undefined);
                                                        setSecurityValue(undefined);
                                                        form.setFieldsValue({
                                                            TotalProgrameSize: "",
                                                            AdvanceRate: undefined,
                                                            TaxRate: undefined,
                                                            MaxLTV: undefined,
                                                            interestRate: undefined,
                                                            commitmentFee: undefined,
                                                            tenorYears: undefined,
                                                            tenorOther: undefined,
                                                            security: undefined,
                                                            guarantorName: undefined,
                                                            uncalledCapital: undefined,
                                                            costBasis: undefined,
                                                            cleanDownRequirement: undefined,
                                                            repaymentBasis: undefined,
                                                            amortizationYears: undefined,
                                                            sweepPercentage: undefined,
                                                            loanStructureType: undefined,
                                                            portfolioCompany: undefined,
                                                            lender: undefined,
                                                            maturityDate: undefined,
                                                            creditFacilityName: undefined,
                                                        });
                                                    }}
                                                    disabled={sponserId > 0}
                                                >
                                                    {loanProgramOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.Name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} xl={12}>
                                            <FormItemInput
                                                label="Credit Facility Name"
                                                name="creditFacilityName"
                                                placeholder="Enter Credit Facility Name"
                                                rules={[{ required: true, message: "Credit Facility Name is required" }]}
                                                maxLength={100}
                                            />
                                        </Col>
                                        {isCorporateLoanProgram && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <FormItemInput
                                                    label="Portfolio Company"
                                                    name="portfolioCompany"
                                                    placeholder="Enter Portfolio Company"
                                                    rules={[{ required: true, message: "Portfolio Company is required" }]}
                                                />
                                            </Col>
                                        )}
                                        {isCorporateLoanProgram && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <Form.Item
                                                    label="Loan Structure"
                                                    name="loanStructureType"
                                                    rules={[{ required: true, message: "Loan Structure is required" }]}
                                                >
                                                    <Select size="large" placeholder="Select Loan Structure">
                                                        {loanStructureTypeOptions.map((item) => (
                                                            <Select.Option key={item.Id} value={item.Id}>
                                                                {item.Name}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                        )}
                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <FormItemInput
                                                label="Firm (Client Employer)"
                                                name="firm"
                                                placeholder="Enter Firm (Client Employer)"
                                                rules={[
                                                    { required: true, message: "Firm (Client Employer) is required" },
                                                ]}
                                            // disabled={sponserId > 0}
                                            />
                                        </Col> */}

                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <FormItemPhoneNumber
                                                label="Business Phone"
                                                name="businessPhone"
                                                form={form}
                                                placeholder="Enter Business Phone"
                                                rules={[
                                                    { required: true, message: "Business Phone is required" },
                                                ]}
                                            />

                                        </Col> */}



                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                          

                                            <FormItemInput
                                                label="Type Of Business"
                                                name="typeOfBusiness"
                                                placeholder="Enter Type Of Business"
                                                rules={[
                                                    { required: true, message: "Type Of Business is required" },
                                                ]}
                                            // disabled={sponserId > 0}
                                            />
                                        </Col> */}

                                        {/* <Col
                                className="gutter-row"
                                xs={{ span: 24 }}
                                lg={{ span: 24 }}
                                md={{ span: 24 }}
                                sm={{ span: 12 }}
                                xl={{ span: 12 }}
                            >
                                <Form.Item
                                    label="Years Associated"
                                    name="yearsAssociated"
                                    rules={[{ required: true, message: 'Years Associated is required' }]}
                                >
                                    <IntegerInput
                                        placeholder="Enter Years Associated"
                                    // disabled={sponserId && sponserId > 0 ? true : false}
                                    />
                                </Form.Item>
                            </Col> */}

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <FormItemCurrencyInput
                                                label="Total Facility Size $"
                                                name="TotalProgrameSize"
                                                placeholder="Enter Total Facility Size"
                                                rules={[
                                                    { required: true, message: "Total Facility Size is required" },
                                                ]}
                                            />

                                        </Col>
                                        {!isCorporateLoanProgram && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <FormItemIntegerInput
                                                    label="Advance Rate %"
                                                    name="AdvanceRate"
                                                    placeholder="Enter Advance Rate"
                                                    maxLength={3}
                                                    rules={[
                                                        { required: true, message: "Advance Rate is required" },
                                                        {
                                                            validator: (_, value) => {
                                                                if (
                                                                    !value ||
                                                                    (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)
                                                                ) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(
                                                                    new Error("Enter a valid 3-digit number (0-999)")
                                                                );
                                                            },
                                                        },
                                                    ]}
                                                />
                                            </Col>
                                        )}


                                        {!isSubscriptionLineOfCredit && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <FormItemIntegerInput
                                                    label="Tax Rate %"
                                                    name="TaxRate"
                                                    placeholder="Enter Tax Rate"
                                                    maxLength={3}
                                                    rules={[
                                                        { required: true, message: "Tax Rate is required" },
                                                        {
                                                            validator: (_, value) => {
                                                                if (
                                                                    !value ||
                                                                    (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)
                                                                ) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(
                                                                    new Error("Enter a valid 3-digit number (0-999)")
                                                                );
                                                            },
                                                        },
                                                    ]}
                                                />
                                            </Col>
                                        )}


                                        {!isSubscriptionLineOfCredit && !isCorporateLoanProgram && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                {/* <Form.Item
                                    label="Max LTV %"
                                    name="MaxLTV"
                                    rules={[
                                        { required: true, message: 'Max LTV is required' },
                                        {
                                            validator: (_, value) => {
                                                if (!value || (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Enter a valid 3-digit number (0-999)'));
                                            },
                                        },
                                    ]}
                                >
                                    <IntegerInput maxLength={3}
                                        placeholder="Enter Max LTV"
                                    />
                                </Form.Item> */}

                                                <FormItemIntegerInput
                                                    label="Max LTV %"
                                                    name="MaxLTV"
                                                    placeholder="Enter Max LTV"
                                                    maxLength={3}
                                                    rules={[
                                                        { required: true, message: "Max LTV is required" },
                                                        {
                                                            validator: (_, value) => {
                                                                if (!value || (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(new Error('Enter a valid 3-digit number (0-999)'));
                                                            },
                                                        },
                                                    ]}
                                                />
                                            </Col>
                                        )}

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            {/* <Form.Item
                                    label="Interest Rate %"
                                    name="interestRate"
                                        rules={[
                                            { required: true, message: 'Interest Rate is required' },
                                            // {
                                            //     validator: (_, value) => {
                                            //         if (!value) return Promise.resolve();

                                            //         // Pattern: 1–40 with up to 2 decimals
                                            //         const pattern = /^\d{1,2}(\.\d{1,2})?$/;

                                            //         if (!pattern.test(value)) {
                                            //             return Promise.reject(
                                            //                 new Error('Enter a valid number from 1 to 40 with up to 2 decimals')
                                            //             );
                                            //         }

                                            //         const num = parseFloat(value);
                                            //         if (num >= 1 && num <= 40) {
                                            //             return Promise.resolve();
                                            //         }

                                            //         return Promise.reject(
                                            //             new Error('Enter a number between 1 and 40 (max 2 decimals)')
                                            //         );
                                            //     },
                                            // },
                                        ]}
                                    >
                                        <IntegerDecimalInput
                                            maxLength={5}
                                            placeholder="Enter Interest Rate"
                                        />
                                    </Form.Item> */}

                                            {/* <FormItemIntegerInput
                                        label="Interest Rate %"
                                        name="interestRate"
                                        placeholder="Enter Interest Rate"
                                        maxLength={5}
                                        rules={[
                                            { required: true, message: 'Interest Rate is required' }
                                        ]}
                                    /> */}
                                            <FormItemDecimalInput
                                                label="Interest Rate %"
                                                name="interestRate"
                                                placeholder="Enter Interest Rate"
                                                maxLength={5}
                                                rules={[
                                                    { required: true, message: 'Interest Rate is required' }
                                                ]}
                                            />

                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <FormItemDecimalInput
                                                label="Commitment Fee %"
                                                name="commitmentFee"
                                                placeholder="Enter Commitment Fee"
                                                maxLength={5}
                                                rules={[
                                                    { required: true, message: 'Commitment Fee is required' }
                                                ]}
                                            />

                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Tenor (Yrs)"
                                                name="tenorYears"
                                                rules={[{ required: true, message: "Tenor (Yrs) is required" }]}
                                            >
                                                <Select
                                                    size="large"
                                                    placeholder="Select Tenor (Yrs)"
                                                    onChange={(value) => {
                                                        setTenorYearsValue(value);
                                                        if (value !== "Demand") {
                                                            form.setFieldsValue({ tenorOther: undefined });
                                                        }
                                                    }}
                                                >
                                                    <Select.Option value="Demand">Demand</Select.Option>
                                                    {Array.from({ length: 10 }, (_, i) => i + 1).map((year) => (
                                                        <Select.Option key={year} value={String(year)}>
                                                            {year}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        {/* {tenorYearsValue === "Demand" && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <FormItemInput
                                                    label="Tenor Other"
                                                    name="tenorOther"
                                                    placeholder="Enter Tenor Details"
                                                    rules={[{ required: true, message: "Tenor Other is required" }]}
                                                />
                                            </Col>
                                        )} */}

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Security"
                                                name="security"
                                                rules={[{ required: true, message: "Security is required" }]}
                                            >
                                                <Select
                                                    size="large"
                                                    placeholder="Select Security"
                                                    onChange={(value) => {
                                                        setSecurityValue(value);
                                                        if (value !== "Guaranteed") {
                                                            form.setFieldsValue({ guarantorName: undefined });
                                                        }
                                                    }}
                                                >
                                                    <Select.Option value="Guaranteed">Guaranteed</Select.Option>
                                                    <Select.Option value="Non-Guaranteed">Non-Guaranteed</Select.Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        {securityValue === "Guaranteed" && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <FormItemInput
                                                    label="Guarantor"
                                                    name="guarantorName"
                                                    placeholder="Enter Guarantor Name"
                                                    rules={[{ required: true, message: "Guarantor is required" }]}
                                                />
                                            </Col>
                                        )}

                                        {!isLoanProgram && !isCorporateLoanProgram && !isCustomIndividualFinancing && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <Form.Item
                                                    label="Uncalled Capital $"
                                                    name="uncalledCapital"
                                                    rules={[{ required: true, message: "Uncalled Capital is required" }]}
                                                >
                                                    <CurrencyInput
                                                        placeholder="Enter Uncalled Capital"
                                                        maxLength={20}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        )}


                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Cost Basis $"
                                                name="costBasis"
                                                rules={[{ required: true, message: "Cost Basis is required" }]}
                                            >
                                                <CurrencyInput
                                                    placeholder="Enter Cost Basis"
                                                    maxLength={20}
                                                />
                                            </Form.Item>
                                        </Col> */}


                                        {!isLoanProgram && !isCorporateLoanProgram && !isCustomIndividualFinancing && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <FormItemInput
                                                    label="Clean-Down Requirement (Days)"
                                                    name="cleanDownRequirement"
                                                    placeholder="Enter Clean-Down Requirement (Days)"
                                                    rules={[{ required: true, message: "Clean-Down Requirement (Days) is required" }]}
                                                />
                                            </Col>
                                        )}


                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            
                                            <FormItemInput
                                                label="Street Address"
                                                name="streetAddress"
                                                placeholder="Enter Street Address"
                                                rules={[
                                                    { required: true, message: "Street Address is required" },
                                                ]}
                                            />
                                        </Col> */}

                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                          

                                            <FormItemInput
                                                label="City"
                                                name="city"
                                                placeholder="Enter City"
                                                rules={[
                                                    { required: true, message: "City is required" },
                                                ]}
                                            />
                                        </Col> */}

                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            
                                            <FormItemInput
                                                label="State"
                                                name="state"
                                                placeholder="Enter State"
                                                rules={[
                                                    { required: true, message: "State is required" },
                                                ]}
                                            />
                                        </Col> */}

                                        {/* <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Zip Code"
                                                name="zip"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Zip Code is required',
                                                    },
                                                    {
                                                        pattern: /^\d{5}(-\d{4})?$/,
                                                        message: 'Enter a valid ZIP Code (e.g., 12345 or 12345-6789)',
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder="Enter Zip Code"
                                                    maxLength={10} // Supports 12345-6789
                                                />
                                            </Form.Item>
                                        </Col> */}


                                        {!isSubscriptionLineOfCredit && (
                                            <Col xs={24} sm={12} xl={12}>
                                                <Form.Item
                                                    label="Repayment Basis"
                                                    name="repaymentBasis"
                                                    rules={[{ required: true, message: "Repayment Basis is required" }]}
                                                >
                                                    <Select
                                                        size="large"
                                                        placeholder="Select Repayment Basis"
                                                        onChange={(value) => {
                                                            const selectedName = corporateRepaymentBasisOptions.find(
                                                                (item) => item.Id === value
                                                            )?.Name;
                                                            setRepaymentBasisNameValue(selectedName);
                                                            if (selectedName !== "Amortization") {
                                                                form.setFieldsValue({ amortizationYears: undefined });
                                                            }
                                                        }}
                                                    >
                                                        {corporateRepaymentBasisOptions.map((item) => (
                                                            <Select.Option key={item.Id} value={item.Id}>
                                                                {item.Name}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                        )}

                                        {!isSubscriptionLineOfCredit && repaymentBasisNameValue === "Amortization" && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <FormItemInput
                                                    label="Amortization (Yrs)"
                                                    name="amortizationYears"
                                                    placeholder="Enter Amortization (Yrs)"
                                                    rules={[{ required: true, message: "Amortization (Yrs) is required" }]}
                                                />
                                            </Col>
                                        )}

                                        {showSweepPercentage && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <FormItemIntegerInput
                                                    label="Sweep %"
                                                    name="sweepPercentage"
                                                    placeholder="Enter Sweep %"
                                                    maxLength={3}
                                                    rules={[
                                                        { required: true, message: "Sweep % is required" },
                                                        {
                                                            validator: (_, value) => {
                                                                if (!value) return Promise.resolve();
                                                                const num = parseInt(value, 10);
                                                                if (/^\d{1,3}$/.test(value) && num >= 50 && num <= 100) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(new Error("Sweep % must be between 50 and 100"));
                                                            },
                                                        },
                                                    ]}
                                                />
                                            </Col>
                                        )}

                                        {/* {(isCorporateLoanProgram || isSubscriptionLineOfCredit) && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <FormItemInput
                                                    label="Lender"
                                                    name="lender"
                                                    placeholder="Enter Lender"
                                                    rules={[{ required: true, message: "Lender is required" }]}
                                                />
                                            </Col>
                                        )} */}
                                        {isCorporateLoanProgram && (
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                <Form.Item
                                                    label="Maturity Date"
                                                    name="maturityDate"
                                                    rules={[{ required: true, message: "Maturity Date is required" }]}
                                                >
                                                    <DatePicker
                                                        size="large"
                                                        allowClear
                                                        className="maturity-date-picker"
                                                        style={{ width: "100%" }}
                                                        format="MM/DD/YYYY"
                                                        placeholder="MM/DD/YYYY"
                                                        disabledDate={(current) => current && current.isSameOrBefore(moment(), 'day')}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        )}

                                        {/* <Col xs={24} sm={12} xl={12} className='H50'>
                                            <Form.Item
                                                label="Asset Class"
                                                name="assetClass"
                                                rules={[{ required: true, message: "Asset Class is required" }]}

                                            >
                                                <Select
                                                    size="large"
                                                    placeholder="Select Asset Class">
                                                    {assetClassOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.Name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col> */}
                                        {/* Fund Type Toggle */}


                                    </Row>
                                </div>

                                {showFundSection && (
                                    <div className='card-section'>
                                        <Title level={5} className='form-title'>Fund</Title>
                                        <Row gutter={[16, 16]}>
                                            <Col xs={24}>
                                                <Form.Item
                                                    label=""
                                                    name="fundType"
                                                    rules={[{ required: !isFundSectionOptional, message: "Fund type is required" }]}
                                                >
                                                    <Radio.Group
                                                        optionType="button"
                                                        buttonStyle="solid"
                                                        className="fund-type-toggle"
                                                        disabled={sponserId > 0}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            setFundType(val);
                                                            if (val === "single") {
                                                                const existing = form.getFieldValue("funds") || [];
                                                                form.setFieldsValue({
                                                                    funds: [existing[0] || { id: 0, fundName: "", assetClass: undefined, fundSize: "", vintageYear: null }],
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        <Radio.Button value="single">Single Fund</Radio.Button>
                                                        <Radio.Button value="multi">Multi Fund</Radio.Button>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </Col>

                                            {/* Dynamic Fund Rows */}
                                            <Col xs={24}>
                                                <Form.List name="funds">
                                                    {(fundFields, { add: addFund, remove: removeFund }) => (
                                                        <>
                                                            {fundFields.map((fundField, fundIndex) => (
                                                                // <Row gutter={[16, 0]} key={fundField.key} align="top" style={{ marginBottom: fundType === "multi" ? 30 : 0 }}>
                                                                <Row gutter={[16, 0]} key={fundField.key} align="top" className="fund-fields-row" style={{ marginBottom: fundType === "multi" ? 30 : 0 }}>
                                                                    <Col xs={24} sm={12} xl={5}>
                                                                        <Form.Item
                                                                            {...fundField}
                                                                            label="Fund Name"
                                                                            name={[fundField.name, "fundName"]}
                                                                            rules={[
                                                                                { required: !isFundSectionOptional, message: "Fund Name is required" },
                                                                                // { pattern: /^[a-zA-Z\s]+$/, message: "Only letters allowed" },
                                                                                {
                                                                                    validator: (_, value) => {
                                                                                        const trimmed = (value || "").trim().toLowerCase();
                                                                                        if (!trimmed) return Promise.resolve();
                                                                                        const funds = form.getFieldValue("funds") || [];
                                                                                        const isDuplicate = funds.some(
                                                                                            (f, idx) => idx !== fundField.name && (f?.fundName || "").trim().toLowerCase() === trimmed
                                                                                        );
                                                                                        return isDuplicate
                                                                                            ? Promise.reject(new Error("Fund Name already exists"))
                                                                                            : Promise.resolve();
                                                                                    },
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Input size="large" placeholder="Enter Fund Name" />
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col xs={24} sm={12} xl={4}>
                                                                        <Form.Item
                                                                            {...fundField}
                                                                            label="Fund Size $"
                                                                            name={[fundField.name, "fundSize"]}
                                                                            rules={[{ required: !isFundSectionOptional, message: "Fund Size is required" }]}
                                                                        >
                                                                            <CurrencyInput
                                                                                size="large"
                                                                                placeholder="Enter Fund Size"
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col xs={24} sm={12} xl={4}>
                                                                        <Form.Item
                                                                            {...fundField}
                                                                            label="Vintage Year"
                                                                            name={[fundField.name, "vintageYear"]}
                                                                            rules={[{ required: !isFundSectionOptional, message: "Vintage Year is required" }]}
                                                                        >
                                                                            <DatePicker
                                                                                size="large"
                                                                                picker="month"
                                                                                format="MM/YYYY"
                                                                                placeholder="MM/YYYY"
                                                                                style={{ width: "100%", height: "50px" }}
                                                                                disabledDate={(current) => current && current.isAfter(moment(), 'month')}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col xs={24} sm={12} xl={5}>
                                                                        <Form.Item
                                                                            {...fundField}
                                                                            label="Asset Class"
                                                                            name={[fundField.name, "assetClass"]}
                                                                            rules={[{ required: !isFundSectionOptional, message: "Asset Class is required" }]}
                                                                        >
                                                                            <Select size="large" placeholder="Select Asset Class">
                                                                                {assetClassOptions.map(item => (
                                                                                    <Select.Option key={item.Id} value={item.Id}>{item.Name}</Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    {fundType === "multi" && (
                                                                        <Col xs={24} xl={6}>
                                                                            <Form.Item label=" ">
                                                                                <Space>
                                                                                    {fundFields.length > 1 && (
                                                                                        <Button
                                                                                            size="large"
                                                                                            type="text"
                                                                                            icon={<DeleteOutlined />}
                                                                                            onClick={() => {
                                                                                                const funds = form.getFieldValue("funds") || [];
                                                                                                const fundName = funds[fundField.name]?.fundName?.trim();
                                                                                                const applicants = form.getFieldValue("applicants") || [];
                                                                                                const isLinked = fundName && applicants.some(
                                                                                                    app => (app?.selectedFunds || []).includes(fundName)
                                                                                                );
                                                                                                if (isLinked) {
                                                                                                    message.error("Fund deletion is not allowed. The selected fund is linked with an applicant.");
                                                                                                    return;
                                                                                                }
                                                                                                removeFund(fundField.name);
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                    {fundIndex === fundFields.length - 1 && (
                                                                                        <ButtonComponent
                                                                                            type="primary"
                                                                                            size="large"
                                                                                            icon={<PlusOutlined />}
                                                                                            onClick={() => addFund({ id: -Date.now(), fundName: "", assetClass: undefined, fundSize: "", vintageYear: null })}
                                                                                            text={<span><PlusOutlined /> Add Fund</span>}
                                                                                        />
                                                                                    )}
                                                                                </Space>
                                                                            </Form.Item>
                                                                        </Col>
                                                                    )}
                                                                </Row>
                                                            ))}
                                                        </>
                                                    )}
                                                </Form.List>
                                            </Col>

                                        </Row>
                                    </div>
                                )}

                                <CreditFacilityReportSection
                                    sponserId={sponserId}
                                    loanProgrameTypeId={creditFacilityValue}
                                    value={reportingRequirements}
                                    onChange={setReportingRequirements}
                                    deletedIds={deletedReportingRequirementIds}
                                    onDeletedIdsChange={setDeletedReportingRequirementIds}
                                />

                                <div className='card-section'>
                                    <Title level={5} className='form-title'>Assign Internal Stakeholders</Title>
                                    <Row gutter={[16, 16]}>
                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Loan Officers"
                                                name="loanOfficers"
                                                rules={[{ required: true, type: 'array', min: 1, message: "Please select a Loan Officer." }]}
                                            >
                                                <Select
                                                    mode="multiple"
                                                    size="large"
                                                    placeholder="Select Loan Officers"
                                                    allowClear
                                                    optionFilterProp="children"
                                                    maxTagCount="responsive"
                                                >
                                                    {loanOfficerOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.Email}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Senior Private Bankers"
                                                name="seniorPrivateBankers"
                                            >
                                                <Select
                                                    mode="multiple"
                                                    size="large"
                                                    placeholder="Select Senior Private Bankers"
                                                    allowClear
                                                    optionFilterProp="children"
                                                    maxTagCount="responsive"
                                                >
                                                    {seniorPrivateBankerOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.Email}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Underwriter Bankers"
                                                name="underwriterBankers"
                                                rules={[{ required: true, type: 'array', min: 1, message: "Please select a Underwriter Banker." }]}
                                            >
                                                <Select
                                                    mode="multiple"
                                                    size="large"
                                                    placeholder="Select Underwriter Bankers"
                                                    allowClear
                                                    optionFilterProp="children"
                                                    maxTagCount="responsive"
                                                >
                                                    {underwriterBankerOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.Email}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Wealth Advisors"
                                                name="privateWealthAdvisors"
                                                rules={[{ required: true, type: 'array', min: 1, message: "Please select a Wealth Advisor." }]}
                                            >
                                                <Select
                                                    mode="multiple"
                                                    size="large"
                                                    placeholder="Select Wealth Advisors"
                                                    allowClear
                                                    optionFilterProp="children"
                                                    maxTagCount="responsive"
                                                >
                                                    {privateWealthAdvisorOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.Email}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 24 }}
                                            md={{ span: 24 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Compliance Administrators"
                                                name="complianceAdministrators"
                                                rules={[{ required: true, type: 'array', min: 1, message: "Please select a Compliance Administrator." }]}
                                            >
                                                <Select
                                                    mode="multiple"
                                                    size="large"
                                                    placeholder="Select Compliance Administrators"
                                                    allowClear
                                                    optionFilterProp="children"
                                                    maxTagCount="responsive"
                                                >
                                                    {complianceAdminOptions.map((item) => (
                                                        <Select.Option key={item.Id} value={item.Id}>
                                                            {item.Email}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>


                                {showUnderwritingCriteriaSection && (
                                    <div className='card-section'>
                                        <Title level={5} className='form-title' >{creditFacilityValue === 2 ? "Underwriting Criteria" : "Set Client Underwriting Criteria"}</Title>
                                        <Row gutter={[16, 16]}>
                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                {/* <Form.Item
                                        name="tdsrThresholdvalue"
                                        label="TDSR Threshold %"
                                        rules={[{ required: true, message: "TDSR Threshold % is required" }]}
                                    >
                                        <IntegerInput
                                            placeholder="Enter TDSR Threshold %"
                                            maxLength={3}
                                        />
                                    </Form.Item> */}

                                                {/* <FormItemIntegerInput
                                        label="TDSR Threshold %"
                                        name="tdsrThresholdvalue"
                                        placeholder="Enter TDSR Threshold %"
                                        maxLength={3}
                                        rules={[
                                            { required: true, message: 'TDSR Threshold % is required' }
                                        ]}
                                    /> */}
                                                <FormItemDecimalInput
                                                    label="TDSR Threshold %"
                                                    name="tdsrThresholdvalue"
                                                    placeholder="Enter TDSR Threshold %"
                                                    maxLength={5}
                                                    rules={[
                                                        { required: true, message: 'TDSR Threshold % is required' }
                                                    ]}
                                                />
                                            </Col>

                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                {/* <Form.Item
                                        name="leverageThresholdvalue"
                                        label="Leverage Threshold"
                                        rules={[{ required: true, message: "Leverage Threshold is required" }]}
                                    >
                                        <IntegerDecimalInput
                                            placeholder="Enter Leverage Threshold"
                                            maxLength={10}
                                        />
                                    </Form.Item> */}

                                                <FormItemDecimalInput
                                                    label="Leverage Threshold"
                                                    name="leverageThresholdvalue"
                                                    placeholder="Enter Leverage Threshold"
                                                    maxLength={10}
                                                    rules={[
                                                        { required: true, message: "Leverage Threshold is required" },
                                                    ]}
                                                />
                                            </Col>

                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                {/* <Form.Item
                                        name="cbrThresholdvalue"
                                        label="CBR Threshold"
                                        rules={[{ required: true, message: "CBR Threshold is required" }]}
                                    >
                                        <IntegerInput
                                            placeholder="Enter CBR Threshold"
                                            maxLength={10}
                                        />
                                    </Form.Item> */}

                                                <FormItemIntegerInput
                                                    label="CBR Threshold"
                                                    name="cbrThresholdvalue"
                                                    placeholder="Enter CBR Threshold"
                                                    maxLength={10}
                                                    rules={[
                                                        { required: true, message: 'CBR Threshold is required' }
                                                    ]}
                                                />
                                            </Col>

                                            <Col
                                                className="gutter-row"
                                                xs={{ span: 24 }}
                                                lg={{ span: 24 }}
                                                md={{ span: 24 }}
                                                sm={{ span: 12 }}
                                                xl={{ span: 12 }}
                                            >
                                                {/* <Form.Item
                                        name="debtIncomeRatioThresholdvalue"
                                        label="Debt Income Ratio Threshold"
                                        rules={[{ required: false, message: "Debt Income Ratio Threshold is required" }]}
                                    >
                                        <IntegerDecimalInput
                                            placeholder="Enter Debt Income Ratio Threshold"
                                            maxLength={10}
                                        />
                                    </Form.Item> */}
                                                <FormItemDecimalInput
                                                    label="Debt Income Ratio Threshold"
                                                    name="debtIncomeRatioThresholdvalue"
                                                    placeholder="Enter Debt Income Ratio Threshold"
                                                    maxLength={10}
                                                    rules={[
                                                        { required: false, message: "Debt Income Ratio Threshold is required" },
                                                    ]}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            </Col>

                            {sponserId && (sponserId > 0) ?
                                <Col className='aligntext donut-chart-col'

                                    xs={{ span: 24 }}
                                    lg={{ span: 24 }}
                                    md={{ span: 24 }}
                                    sm={sponserId && sponserId > 0 ? { span: 8 } : { span: 24 }}
                                    xl={sponserId && sponserId > 0 ? { span: 8 } : { span: 24 }}>
                                    <div className='capital-provider-details card-section'>
                                        <Row justify="center" align="middle" gutter={[16, 16,]}>
                                            <Col span={24}>
                                                <DonutChart data={[
                                                    { type: 'Remaining', value: Number(sponserData && sponserData.Remaining) },
                                                    { type: 'Utilized', value: Number(sponserData && sponserData.Utilized) },

                                                ]}
                                                    title="Budget"
                                                />
                                            </Col>
                                            <Col span={24}>
                                                <div className=' budget-details-div'>
                                                    <Title level={5}>
                                                        Utilized:
                                                    </Title>
                                                    <span>
                                                        ${_commonService.formatNumberWithCommas(sponserData.Utilized)}
                                                    </span>
                                                </div>
                                                <div className=' budget-details-div'>
                                                    <Title level={5}>
                                                        Remaining:
                                                    </Title>
                                                    <span>
                                                        ${_commonService.formatNumberWithCommas(sponserData.Remaining)}
                                                    </span>
                                                </div>
                                                <Divider className='divider' />

                                                <div className=' budget-details-div'>
                                                    <Title level={5}>
                                                        Total Allocation:
                                                    </Title>
                                                    <span>
                                                        ${_commonService.formatNumberWithCommas(sponserData.TotalProgrameSize)}

                                                    </span>
                                                </div>

                                                <Divider className='divider' />
                                            </Col>

                                            {!isCorporateLoanProgram && !isSubscriptionLineOfCredit && (
                                                <Col span={24} className=''>
                                                    <Row
                                                        gutter={[16, 16]}
                                                        className="active-loans-row">
                                                        <Col span={24}>
                                                            <Title
                                                                level={5}
                                                            >
                                                                Active Loan Programs
                                                            </Title>
                                                        </Col>
                                                        <Col span={11} className='active-loans-data' style={{ marginRight: "16px" }}>

                                                            <div className=' budget-details-div-1' >
                                                                <Title level={5}>
                                                                    In Progress:
                                                                </Title>
                                                                <span>
                                                                    {_commonService.formatNumberWithCommas(sponserData.Inprogressed)}

                                                                </span>
                                                            </div>
                                                        </Col>

                                                        <Col span={11} className='active-loans-data'>

                                                            <div className='budget-details-div-1'>
                                                                <Title level={5}>
                                                                    Funded:
                                                                </Title>
                                                                <span>
                                                                    {_commonService.formatNumberWithCommas(sponserData.Approved)}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            )}
                                        </Row></div>

                                </Col>
                                : <></>
                            }
                        </Row>

                        {sponserId && (sponserId > 0) ?
                            <>
                                {loading ? null :
                                    <ApplicationList
                                        allApplications={allApplications}
                                        loading={loading}
                                        pageIndex={pageIndex}
                                        pageSize={pageSize}
                                        totalCount={totalCount}
                                        onPaginationChange={handlePaginationChange}
                                        searchTerm={searchTerm}
                                        fromDate={fromDate}
                                        toDate={toDate}
                                        sortBy={sortBy}
                                        onSearchChange={setSearchTerm}
                                        fromDateChange={setFromDate}
                                        toDateChange={setToDate}
                                        onSortChange={setSortBy}
                                        onClearFilters={handleClearFilters}
                                        onApplicationStatusChange={setApplicationStatus}
                                        applicationStatusForFilter={applicationStatus}
                                    />
                                }
                            </>
                            : <></>
                        }


                        <Collapse
                            className={sponserId && sponserId > 0 ? 'collapseHeaderColor card-section' : 'collapseHeaderColor card-section'}
                            activeKey={activePanelKey}
                            onChange={(keys) => setActivePanelKey(keys)}
                            expandIcon={({ isActive }) => (
                                isActive ? <DownOutlined /> :
                                    <UpOutlined />
                            )}
                            expandIconPlacement="end"

                        >
                            <Panel
                                key="1"
                                showArrow={true}
                                // collapsible={sponserId && sponserId > 0 ? undefined : "disabled"}
                                header={
                                    <div
                                        onClick={() => {
                                            // Only allow toggle if sponserId > 0
                                            if (!(sponserId > 0)) return;

                                            if (isAnyApplicantEmpty()) {
                                                message.warning("Please enter all fields for each applicant or remove empty applicants");
                                                return;
                                            }

                                            setActivePanelKey((prevKeys) =>
                                                prevKeys.includes("1") ? [] : ["1"]
                                            );
                                        }}
                                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                                    >
                                        <Title level={5} style={{ margin: 0 }}>
                                            {(isCorporateLoanProgram || isSubscriptionLineOfCredit) ? "Firm Administrator Details" : "Individual Participant Details"}
                                        </Title>
                                        {/* {(form.getFieldValue('applicants') || []).length === 0 && ( */}
                                        {!isCorporateLoanProgram && !isSubscriptionLineOfCredit &&
                                            <ButtonComponent
                                                type="primary"
                                                icon={<PlusOutlined />}
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent header toggle
                                                    addClickedRef.current = true;

                                                    const existing = form.getFieldValue('applicants') || [];
                                                    form.setFieldsValue({
                                                        applicants: [...existing, {
                                                            name: "",
                                                            contactNumber: "",
                                                            email: "",
                                                            gpCommitment: null,
                                                            roleId: existing.length === 0 ? 6 : "",
                                                            selectedFunds: [],
                                                        }]
                                                    });

                                                    setExistingFirmAdminChecked(false);
                                                    setAutoFocusApplicantIndex(existing.length);
                                                    setActivePanelKey(['1']); // Keep panel open
                                                }}
                                                text={
                                                    <span>
                                                        <PlusOutlined />   Add New Participant
                                                    </span>
                                                }

                                            />
                                        }
                                    </div>
                                }
                            >
                                <Form.List name="applicants">
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map((field, index) => {
                                                const isFirmAdminReadOnly = index === 0 && existingFirmAdminChecked;
                                                return (
                                                <Card
                                                    key={field.key}
                                                    type="inner"
                                                    className='card-section'
                                                >
                                                    <Row gutter={[16, 16]}>
                                                        <Col className="gutter-row" span={24}>
                                                            <Title level={5} className='form-title'>
                                                                {(isCorporateLoanProgram || isSubscriptionLineOfCredit) ? "Firm Administrator" : `Application ${index + 1}`}
                                                            </Title>
                                                        </Col>
                                                        {index === 0 && isExistingFirmSelected && (
                                                            <Col className="gutter-row" span={24}>
                                                                <Checkbox
                                                                    checked={existingFirmAdminChecked}
                                                                    onChange={(e) => handleExistingFirmAdminChange(e, form)}
                                                                >
                                                                    Existing Firm Admin
                                                                </Checkbox>
                                                            </Col>
                                                        )}
                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 24 }}
                                                            lg={{ span: 24 }}
                                                            md={{ span: 24 }}
                                                            sm={{ span: 12 }}
                                                            xl={{ span: 12 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Client First Name"
                                                                name={[field.name, 'name']}
                                                                fieldKey={[field.fieldKey, 'name']}

                                                            >
                                                                <Input
                                                                    placeholder="Enter Client First Name"
                                                                    ref={input => {
                                                                        if (autoFocusApplicantIndex === index && input) {
                                                                            input.focus();
                                                                            setAutoFocusApplicantIndex(null); // reset so it doesn't repeat
                                                                        }
                                                                    }}
                                                                    disabled={(form.getFieldValue('applicants')[field.name].isApplicantRegistered || isFirmAdminReadOnly) ? true : false}
                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 24 }}
                                                            lg={{ span: 24 }}
                                                            md={{ span: 24 }}
                                                            sm={{ span: 12 }}
                                                            xl={{ span: 12 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Client Middle Name"
                                                                name={[field.name, 'middleName']}
                                                                fieldKey={[field.fieldKey, 'middleName']}
                                                                // rules={[
                                                                //     { required: false, max: 1, message: "Only one character allowed" },
                                                                // ]}
                                                            >
                                                                <Input
                                                                    placeholder="Enter Client Middle Name"
                                                                    disabled={(form.getFieldValue('applicants')[field.name].isApplicantRegistered || isFirmAdminReadOnly) ? true : false}
                                                                    maxLength={30}
                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 24 }}
                                                            lg={{ span: 24 }}
                                                            md={{ span: 24 }}
                                                            sm={{ span: 12 }}
                                                            xl={{ span: 12 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Client Last Name"
                                                                name={[field.name, 'lastName']}
                                                                fieldKey={[field.fieldKey, 'lastName']}

                                                            >
                                                                <Input
                                                                    placeholder="Enter Client Last Name"
                                                                    disabled={(form.getFieldValue('applicants')[field.name].isApplicantRegistered || isFirmAdminReadOnly) ? true : false}
                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 24 }}
                                                            lg={{ span: 24 }}
                                                            md={{ span: 24 }}
                                                            sm={{ span: 12 }}
                                                            xl={{ span: 12 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Email"
                                                                name={[field.name, 'email']}
                                                                fieldKey={[field.fieldKey, 'email']}
                                                                rules={[
                                                                    { required: true, message: 'Email is required' },
                                                                    { type: 'email', message: 'Enter a valid Email' },
                                                                    // ({ getFieldValue }) => ({
                                                                    //     validator(_, value) {
                                                                    //         const applicants = getFieldValue("applicants") || [];
                                                                    //         const email = value?.toLowerCase().trim();
                                                                    //         const duplicateCount = applicants.filter(
                                                                    //             (item, i) =>
                                                                    //                 i !== index &&
                                                                    //                 item?.email?.toLowerCase().trim() === email
                                                                    //         ).length;

                                                                    //         if (duplicateCount > 0) {
                                                                    //             return Promise.reject(new Error("Duplicate email found"));
                                                                    //         }

                                                                    //         return Promise.resolve();
                                                                    //     },
                                                                    // }),
                                                                ]}
                                                            >
                                                                <Input
                                                                    placeholder="Enter Email"
                                                                    disabled={(form.getFieldValue('applicants')[field.name].isApplicantRegistered || isFirmAdminReadOnly) ? true : false}
                                                                    maxLength={50}
                                                                />
                                                            </Form.Item>
                                                        </Col>


                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 24 }}
                                                            lg={{ span: 24 }}
                                                            md={{ span: 24 }}
                                                            sm={{ span: 12 }}
                                                            xl={{ span: 12 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Confirm Email"
                                                                name={[field.name, 'confirmemail']}
                                                                fieldKey={[field.fieldKey, 'confirmemail']}
                                                                dependencies={[[field.name, 'email']]}
                                                                rules={[
                                                                    { required: true, message: 'Confirm Email is required' },
                                                                    { type: 'email', message: 'Enter a valid Email' },
                                                                    ({ getFieldValue }) => ({
                                                                        validator(_, value) {
                                                                            const email = getFieldValue(['applicants', field.name, 'email']);
                                                                            if (!value || email === value) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            return Promise.reject(new Error("Email and Confirm Email do not match"));
                                                                        }
                                                                    })
                                                                ]}
                                                            >
                                                                <Input
                                                                    placeholder="Enter Confirm Email"
                                                                    onCopy={(e) => e.preventDefault()}
                                                                    onCut={(e) => e.preventDefault()}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    disabled={(form.getFieldValue('applicants')[field.name].isApplicantRegistered || isFirmAdminReadOnly) ? true : false}
                                                                    maxLength={50}
                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 24 }}
                                                            lg={{ span: 24 }}
                                                            md={{ span: 24 }}
                                                            sm={{ span: 12 }}
                                                            xl={{ span: 12 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Contact Number"
                                                                name={[field.name, 'contactNumber']}
                                                                fieldKey={[field.fieldKey, 'contactNumber']}
                                                                rules={[
                                                                    { required: true, message: 'Contact Number is required' },
                                                                    {
                                                                        validator: (_, value) => {
                                                                            if (!value) {
                                                                                return Promise.resolve(); //  Allow empty value if not required
                                                                            }
                                                                            const digits = value.replace(/\D/g, '');
                                                                            if (digits.length === 10) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            return Promise.reject(
                                                                                new Error("Wrong format! please use this format (XXX) XXX-XXXX")
                                                                            );
                                                                        },
                                                                    }
                                                                ]}
                                                            >
                                                                <PhoneInput
                                                                    placeholder="Enter Contact Number"
                                                                    inputComponent={Input}
                                                                    autoComplete="off"
                                                                    onChange={(value) => {
                                                                        // Remove non-digit characters and store the raw number
                                                                        const digits = value.replace(/\D/g, '');
                                                                        const applicants = form.getFieldValue('applicants') || [];
                                                                        const updatedApplicants = [...applicants];
                                                                        updatedApplicants[field.name] = {
                                                                            ...updatedApplicants[field.name],
                                                                            contactNumber: digits
                                                                        };
                                                                        form.setFieldsValue({ applicants: updatedApplicants });
                                                                    }}
                                                                    disabled={(form.getFieldValue('applicants')[field.name].isApplicantRegistered || isFirmAdminReadOnly) ? true : false}
                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        {!(isCorporateLoanProgram || isSubscriptionLineOfCredit) && (
                                                            <Form.Item
                                                                noStyle
                                                                shouldUpdate={(prev, curr) => prev.applicants !== curr.applicants || prev.creditFacility !== curr.creditFacility}
                                                            >
                                                                {() => {
                                                                    const applicants = form.getFieldValue("applicants") || [];
                                                                    const current = applicants[field.name] || {};
                                                                    const isFirmAdminRow = current.roleId === 6;

                                                                    // Firm Administrator without Requires Loan Application is account-only --
                                                                    // no real loan application gets created in that case, so the GP Commitment
                                                                    // Amount (which only applies once a real application exists) is hidden and
                                                                    // not required. Non-Firm-Admin participants are unaffected.
                                                                    if (isFirmAdminRow && !current.requiresApplication) {
                                                                        return null;
                                                                    }

                                                                    return (
                                                                        <Col
                                                                            className="gutter-row"
                                                                            xs={{ span: 24 }}
                                                                            lg={{ span: 24 }}
                                                                            md={{ span: 24 }}
                                                                            sm={{ span: 12 }}
                                                                            xl={{ span: 12 }}
                                                                        >
                                                                            <Form.Item
                                                                                {...field}
                                                                            label={(isCorporateLoanProgram || isSubscriptionLineOfCredit) ? "Commitment Amount $" : "Prospective GP Commitment Amount $"}


                                                                                name={[field.name, 'gpCommitment']}
                                                                                fieldKey={[field.fieldKey, 'gpCommitment']}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: 'Prospective GP Commitment Amount is required',
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <CurrencyInput
                                                                                    placeholder={creditFacilityValue === 2 ? "Enter Commitment Amount" : "Enter Prospective GP Commitment Amount"}
                                                                                    maxLength={20}
                                                                                    disabled={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? true : false}
                                                                                />
                                                                            </Form.Item>
                                                                        </Col>
                                                                    );
                                                                }}
                                                            </Form.Item>
                                                        )}
                                                        {/* Select Role, Requires Loan Application, Delete Client and Resend Email OTP are laid
                                                        out as one row of equally-spaced items (via a single Space) instead of separate grid
                                                        columns -- fixed-width columns can't give equal visual gaps when the item labels are
                                                        different lengths. */}
                                                        <Col
                                                            className="gutter-row"
                                                            xs={{ span: 24 }}
                                                            lg={{ span: 24 }}
                                                            md={{ span: 24 }}
                                                            sm={{ span: 12 }}
                                                            xl={{ span: 12 }}
                                                        >
                                                            <Form.Item
                                                                label="Select Role"
                                                                shouldUpdate={(prev, curr) =>
                                                                    prev.applicants !== curr.applicants ||
                                                                    prev.creditFacility !== curr.creditFacility
                                                                }
                                                            >
                                                                {() => {
                                                                    const applicants = form.getFieldValue("applicants") || [];
                                                                    const current = applicants[field.name] || {};
                                                                    const isChecked = current.roleId === 6;

                                                                    return (
                                                                        <Space size={8} wrap align="center">
                                                                            <Checkbox
                                                                                checked={isChecked}
                                                                                onChange={(e) => handleRoleChange(e, field, form)}
                                                                                disabled={
                                                                                    isCorporateLoanProgram ||
                                                                                    isSubscriptionLineOfCredit ||
                                                                                    current?.isApplicantRegistered ||
                                                                                    isFirmAdminReadOnly
                                                                                }
                                                                            >
                                                                                Firm Administrator
                                                                            </Checkbox>

                                                                            {/* Firm Administrator, Loan Program / Custom Individual Financing only -- lets the
                                                                            banker opt this specific Firm Administrator into also getting a real loan
                                                                            application (full client workflow) once they register, instead of the default
                                                                            account-only behavior. Only shown for the row currently marked Firm Administrator. */}
                                                                            {isChecked && !isCorporateLoanProgram && !isSubscriptionLineOfCredit && (
                                                                                <Checkbox
                                                                                    checked={!!current.requiresApplication}
                                                                                    onChange={(e) => {
                                                                                        const updatedApplicants = [...(form.getFieldValue("applicants") || [])];
                                                                                        updatedApplicants[field.name] = {
                                                                                            ...updatedApplicants[field.name],
                                                                                            requiresApplication: e.target.checked,
                                                                                        };
                                                                                        form.setFieldsValue({ applicants: updatedApplicants });
                                                                                    }}
                                                                                >
                                                                                    Requires Loan Application
                                                                                </Checkbox>
                                                                            )}

                                                                            {fields.length > 0 && (
                                                                                <>
                                                                                    <Tooltip
                                                                                        title={
                                                                                            (current.isApplicantRegistered || isCorporateLoanProgram || isSubscriptionLineOfCredit)
                                                                                                ? null
                                                                                                : 'Delete Client'
                                                                                        }
                                                                                    >
                                                                                        <Button
                                                                                            type="text"
                                                                                            icon={
                                                                                                <DeleteOutlined
                                                                                                    className={(current.isApplicantRegistered || isCorporateLoanProgram || isSubscriptionLineOfCredit) ? 'iconDisabledColor' : ""}
                                                                                                />
                                                                                            }
                                                                                            onClick={() => handleDeleteApplicant(field, remove, form, index)}
                                                                                            disabled={(current.isApplicantRegistered || isCorporateLoanProgram || isSubscriptionLineOfCredit) ? true : false}
                                                                                        />
                                                                                    </Tooltip>

                                                                                    {!isCorporateLoanProgram && current.id > 0 && !current.isApplicantRegistered && (
                                                                                        <div className='blockAlign'>
                                                                                            <Space size={16}>
                                                                                                <Tooltip title="Resend Email OTP">
                                                                                                    <Button
                                                                                                        type="link"
                                                                                                        icon={<ReloadOutlined />}
                                                                                                        onClick={() => handleResendEmailOTP(field, form)}
                                                                                                        className='text-label-class'
                                                                                                    >
                                                                                                        Resend Email OTP
                                                                                                    </Button>
                                                                                                </Tooltip>
                                                                                                <Tooltip title={`Last verification Email sent on ${current.lastEmailSentDateTime ? _commonService.formatDateTimeAMPM(current.lastEmailSentDateTime) : null}`}>
                                                                                                    <div className='text-label-class' >{current.lastEmailSentDateTime ? _commonService.formatDateTimeAMPM(current.lastEmailSentDateTime) : null}</div>
                                                                                                </Tooltip>
                                                                                            </Space>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </Space>
                                                                    );
                                                                }}
                                                            </Form.Item>
                                                        </Col>

                                                        {/* <Col
                                                            className="gutter-row"
                                                            xs={{ span: 12 }}
                                                            lg={{ span: 12 }}
                                                            md={{ span: 12 }}
                                                            sm={{ span: 8 }}
                                                            xl={{ span: 8 }}
                                                        >
                                                            <Form.Item
                                                                {...field}
                                                                label="Interest Expense %"
                                                                name={[field.name, 'interestExpense']}
                                                                fieldKey={[field.fieldKey, 'interestExpense']}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Interest Expense % is required',
                                                                    },
                                                                    {
                                                                        pattern: /^\d+(\.\d{1,2})?$/,
                                                                        message: "Enter a valid amount",
                                                                    }
                                                                ]}
                                                            >
                                                                <PercentInput
                                                                    placeholder="Enter Interest Expense %"
                                                                    maxLength={20}
                                                                    disabled={form.getFieldValue('applicants')[field.name].isApplicantRegistered ? true : false}
                                                                />
                                                            </Form.Item>
                                                        </Col> */}

                                                        {!isCorporateLoanProgram && (
                                                            <Col
                                                                className="gutter-row"
                                                                xs={{ span: 24 }}
                                                                lg={isSubscriptionLineOfCredit ? { span: 24 } : { span: 12 }}
                                                                md={isSubscriptionLineOfCredit ? { span: 24 } : { span: 12 }}
                                                                sm={isSubscriptionLineOfCredit ? { span: 24 } : { span: 8 }}
                                                                xl={isSubscriptionLineOfCredit ? { span: 24 } : { span: 8 }}
                                                            >
                                                                <Form.Item
                                                                    noStyle
                                                                    shouldUpdate={(prevValues, curValues) => prevValues.funds !== curValues.funds}
                                                                >
                                                                    {({ getFieldValue }) => {
                                                                        const funds = getFieldValue("funds") || [];

                                                                        const fundOptions = funds
                                                                            .filter(f => f?.fundName?.trim())
                                                                            .map(f => ({
                                                                                label: f.fundName.trim(),
                                                                                value: f.id,
                                                                            }));

                                                                        return (
                                                                            <Form.Item
                                                                                label="Select Funds"
                                                                                name={[field.name, "selectedFunds"]}
                                                                                style={{
                                                                                    display: fundOptions.length ? undefined : "none",
                                                                                }}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        validator: (_, value) => {
                                                                                            if (!fundOptions.length) {
                                                                                                return Promise.resolve();
                                                                                            }

                                                                                            return value?.length
                                                                                                ? Promise.resolve()
                                                                                                : Promise.reject(
                                                                                                    new Error("Please select at least one Fund")
                                                                                                );
                                                                                        },
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <Checkbox.Group options={fundOptions} />
                                                                            </Form.Item>
                                                                        );
                                                                    }}
                                                                </Form.Item>
                                                            </Col>
                                                        )}

                                                    </Row>
                                                    {sponserId > 0 && (
                                                        <Row justify="end" style={{ marginTop: 16 }}>
                                                            <Col>
                                                                <ButtonComponent
                                                                    type="primary"
                                                                    // loading={loading}
                                                                    onClick={handleSaveApplicant}
                                                                    text="Save Participant"
                                                                    disabled={(sponserData?.sponserApplicantModels || []).some(item => item.Id === 0)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    )}
                                                </Card>
                                                );
                                            })}
                                        </>
                                    )}
                                </Form.List>
                                {!isCorporateLoanProgram && !isSubscriptionLineOfCredit && (
                                    <ButtonComponent
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevent header toggle
                                            addClickedRef.current = true;

                                            const existing = form.getFieldValue('applicants') || [];
                                            form.setFieldsValue({
                                                applicants: [...existing, {
                                                    name: "",
                                                    contactNumber: "",
                                                    email: "",
                                                    gpCommitment: null,
                                                    roleId: existing.length === 0 ? 6 : "",
                                                    // interestExpense: ""
                                                }]
                                            });

                                            setExistingFirmAdminChecked(false);
                                            setAutoFocusApplicantIndex(existing.length);
                                            setActivePanelKey(['1']); // Keep panel open
                                        }}
                                        text={
                                            <span>
                                                <PlusOutlined />   Add New Participant
                                            </span>
                                        }
                                        // text="Add Applicant"
                                        className='add-applicant-button'
                                    />
                                )}

                                {sponserData && sponserData.applicants && sponserData.applicants.length == 0 &&
                                    form.getFieldValue('applicants') && form.getFieldValue('applicants').length == 0 &&
                                    (
                                        <div className="textCenterAlign">No Applicants added yet</div>
                                    )}
                            </Panel>
                        </Collapse>


                        <Divider />

                        <div className="mt10" style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>

                            <Form.Item>
                                {/* <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                    className=''
                                >
                                    Go Back
                                </Button> */}
                                <ButtonComponent
                                    type='default'
                                    onClick={onBack}
                                    text={"Go Back"}
                                    icon={<LeftOutlined />}
                                    iconPosition="left"
                                />

                            </Form.Item>

                            <Form.Item>
                                <ButtonComponent
                                    type='primary'
                                    onClick={() => {
                                        confirm({
                                            title: "Are you sure you want to submit the Credit Facility?",
                                            icon: <ExclamationCircleOutlined />,
                                            okText: <span id="yesBtn">Yes</span>,
                                            cancelText: <span id="noBtn">No</span>,
                                            okType: "primary",
                                            onOk() {
                                                form.submit();
                                            },
                                        });
                                    }}
                                    text={"Submit"}
                                />
                            </Form.Item>
                        </div>
                    </Form>
                </Card>

                <Modal
                    title="Delete Credit facility"
                    open={isModalOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    closable
                    className='deleteLoanProgramModal'
                >
                    <Text>Note: This action will delete Credit Facility & all the Individual Applicants under this Credit Facility <Text strong>({sponserData && sponserData.CompanyName})</Text></Text>
                    <div>
                        <label className="label-align mt10">Banker Login Password<span className="asterick-color">*</span></label>
                    </div>
                    <Input.Password
                        autoComplete="current-password"
                        placeholder="Enter Banker Login Password"
                        maxLength={30}
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setPasswordError("");
                        }}
                    />
                    {passwordError && (
                        <div style={{ display: "block", marginTop: 8, color: "#ff4d4f" }}>
                            {passwordError}
                        </div>
                    )}
                </Modal>
            </SidebarLayout>
            </Spin>
        </>
    );
};

export default AddEditSponsers;